<template>
  <div id="dashboard-analytics">
    <div class="vx-row" id="destinationclient">
      <div class="vx-col lg:w-full w-full">
        <vx-card :title="value_unpaid_invoice" class="mb-4">
          <div slot="no-body" class="mt-4 ml-4 mr-4 mb4">
            <!--<vs-button @click="findMatchingBanksInvoices">1. Check Match</vs-button>
            <vs-button class="ml-4" @click="findTransactionsEUR">2. Display Transactions (EUR)</vs-button>
            <vs-button class="ml-4" @click="findTransactionsRON">3. Display Transactions (RON)</vs-button>-->

            <div class="legend mt-8">
              <div class="legend-item">
                <div class="h-3 w-3 rounded-full mr-2" style="background-color: #4775d1;"></div>
                <span>Invoice not sent to client</span>
              </div>
              <div class="legend-item">
                <div class="h-3 w-3 rounded-full mr-2 bg-danger"></div>
                <span>Payment Overdue</span>
              </div>
              <div class="legend-item">
                <div class="h-3 w-3 rounded-full mr-2 bg-warning"></div>
                <span>Due Today</span>
              </div>
              <div class="legend-item">
                <div class="h-3 w-3 rounded-full mr-2 bg-success"></div>
                <span>On Track</span>
              </div>
            </div>

            <vs-table :data="unpaid_invoice" class="table-dark-inverted mt-8" >
              <template slot="thead">
                <vs-th>Invoice No</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Date</vs-th>
                <vs-th>Client</vs-th>
                <vs-th style="float: right">Excl. VAT (EUR)</vs-th>
                <vs-th>VAT (%)</vs-th>
                <vs-th style="float: right">Incl. VAT (EUR)</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span v-if="tr.invoice_no.length > 25">
                      {{ tr.invoice_no.substring(0, 25) }}...
                    </span>
                    <span v-else>
                      {{ tr.invoice_no }}
                    </span>
                  </vs-td>
                  <vs-td>
                    <span v-if="tr.isadvanceinvoice === 'true'">Advance</span>
                    <span v-else-if="tr.iscreditnote === 'true'">Credit</span>
                    <span v-else-if="tr.isadvanceinvoice === 'false'">Final</span>
                    <span v-else>Advance+Final</span>
                  </vs-td>
                  <vs-td>
                    <span v-if="tr.late && tr.late > 0" class="flex items-center px-2 py-1 rounded">
                      <div class="h-3 w-3 rounded-full mr-2" style="background-color: #4775d1;"
                        v-if="!tr.mailtoclientsent"></div>
                      <div class="h-3 w-3 rounded-full mr-2" :class="'bg-success'"></div>
                      {{ tr.deadline }} (deadline in
                      {{ tr.late }} days)
                    </span>
                    <span v-else-if="tr.late && tr.late <= 0" class="flex items-center px-2 py-1 rounded">
                      <div class="h-3 w-3 rounded-full mr-2" style="background-color: #4775d1;"
                        v-if="!tr.mailtoclientsent"></div>
                      <div class="h-3 w-3 rounded-full mr-2" :class="'bg-danger'"></div>
                      {{ tr.deadline }} ({{
                        Math.abs(tr.late)
                      }}
                      days late)
                    </span>
                    <span v-else class="flex items-center px-2 py-1 rounded">
                      <div class="h-3 w-3 rounded-full mr-2" style="background-color: #4775d1;"
                        v-if="!tr.mailtoclientsent"></div>
                      <div class="h-3 w-3 rounded-full mr-2" :class="'bg-warning'"></div>
                      {{ tr.deadline }} (N/A)
                    </span>
                  </vs-td>
                  <vs-td>
                    <span v-if="tr.client.length > 25">
                      <a :href="getClientUrl(tr.clientid)
                        ">{{ tr.client.substring(0, 20) }}... </a> ({{ tr.payment_due_day }} days to pay)
                    </span>
                    <span v-else>
                      <a :href="getClientUrl(tr.clientid)
                        ">{{ tr.client }}</a>
                      ({{ tr.payment_due_day }} days to pay)
                    </span>
                    <span v-if="tr.has_dispute" class="dispute-badge">DISPUTE</span>
                  </vs-td>
                  <vs-td>
                    <span style="float: right">
                      <feather-icon v-if="tr.sum_partially_paid" style="color: red" icon="AlertTriangleIcon"
                        svgClasses="h-5 w-5" />&nbsp;&nbsp;{{
                          Math.abs(tr.prix).toFixed(2).toLocaleString()
                        }}</span>
                  </vs-td>
                  <vs-td>
                    <span style="float: right">
                      <feather-icon v-if="tr.sum_partially_paid" style="color: red" icon="AlertTriangleIcon"
                        svgClasses="h-5 w-5" />&nbsp;&nbsp;{{
                          getVatStr(tr.subject_vat, tr.country_code)
                        }}</span>
                  </vs-td>
                  <vs-td>
                    <span style="float: right" v-if="Math.abs(tr.prix * getVat(tr.subject_vat, tr.country_code)) > 0">
                      <feather-icon v-if="tr.sum_partially_paid" style="color: red" icon="AlertTriangleIcon"
                        svgClasses="h-5 w-5" />&nbsp;&nbsp;{{
                          Math.abs(tr.prix * getVat(tr.subject_vat, tr.country_code)).toFixed(2).toLocaleString()
                        }}</span>
                    <span style="float: right" v-else>
                      <feather-icon v-if="tr.sum_partially_paid" style="color: red" icon="AlertTriangleIcon"
                        svgClasses="h-5 w-5" />&nbsp;&nbsp;{{
                          "N/A"
                        }}</span>
                  </vs-td>

                  <template slot="expand">
                    <vs-table :data="tr.detail" style="width: 100%" stripe>
                      <vs-tr :data="trr" :key="indextrr" v-for="(trr, indextrr) in tr.detail">
                        <vs-td>
                          <a :href="getInvoiceUrl(tr.detail[indextrr].id)
                            ">{{ tr.detail[indextrr].invoice_no }}</a>
                            <span v-if="tr.detail[indextrr].dispute" class="dispute-badge">DISPUTE</span>
                            <br v-if="tr.detail[indextrr].dispute_comment" />
                            <small v-if="tr.detail[indextrr].dispute_comment" class="dispute-comment">{{ tr.detail[indextrr].dispute_comment }}</small>
                        </vs-td>
                        <vs-td style="width: 130px">
                          <span v-if="tr.detail[indextrr]
                            .isadvanceinvoice === true
                          ">Advance</span>
                          <span v-else-if="tr.detail[indextrr].iscreditnote ===
                            true
                          ">Credit Note</span>
                          <span v-else-if="tr.detail[indextrr]
                            .isadvanceinvoice === false && tr.detail[indextrr]
                              .idinvoicemajoration == -1
                          ">Majoration</span>
                          <span v-else-if="tr.detail[indextrr]
                            .isadvanceinvoice === false
                          ">Final</span>
                          <span v-else>Advance and Final invoices</span>
                        </vs-td>
                        <vs-td>
                          <span v-if="tr.detail[indextrr].late &&
                            tr.detail[indextrr].late > 0
                          " class="flex items-center px-2 py-1 rounded">
                            <div class="h-3 w-3 rounded-full mr-2" :class="'bg-success'"></div>
                            <small>{{ tr.detail[indextrr].deadline }}
                              <br />(deadline in
                              {{ tr.detail[indextrr].late }} days)</small>
                          </span>
                          <span v-else-if="tr.detail[indextrr].late &&
                            tr.detail[indextrr].late <= 0
                          " class="flex items-center px-2 py-1 rounded">
                            <div class="h-3 w-3 rounded-full mr-2" :class="'bg-danger'"></div>
                            <small>{{ tr.detail[indextrr].deadline }}<br />({{
                              Math.abs(tr.detail[indextrr].late)
                            }}
                              days late)</small>
                          </span>
                          <span v-else class="flex items-center px-2 py-1 rounded">
                            <div class="h-3 w-3 rounded-full mr-2" :class="'bg-warning'"></div>
                            <small>{{ tr.detail[indextrr].deadline }} (N/A)</small>
                          </span>
                        </vs-td>
                        <vs-td>
                          <span v-if="tr.detail[indextrr].amountpartiallypaid
                          " style="float: left">
                            <small>Paid:
                              {{
                                Math.abs(
                                  tr.detail[indextrr]
                                    .amountpartiallypaid
                                )
                                  .toFixed(2)
                                  .toLocaleString()
                              }}
                              EUR<br />
                              Remaining:
                              <feather-icon style="color: red" icon="AlertTriangleIcon" svgClasses="h-5 w-5" />{{
                                (
                                  Math.abs(
                                    tr.detail[indextrr].prix
                                  ).toFixed(2) -
                                  Math.abs(
                                    tr.detail[indextrr]
                                      .amountpartiallypaid
                                  ).toFixed(2)
                                ).toLocaleString()
                              }}EUR excl. VAT<br />Total:
                              {{
                                Math.abs(tr.detail[indextrr].prix)
                                  .toFixed(2)
                                  .toLocaleString()
                              }}
                              EUR excl. VAT</small>
                          </span>
                          <span v-else style="float: left">
                            <span
                              v-if="getVatStr(tr.detail[indextrr].subject_vat, tr.detail[indextrr].country_code) === 'N/A'">{{
                                Math.abs(tr.detail[indextrr].prix)
                                  .toFixed(2)
                                  .toLocaleString()
                              }}
                              EUR</span>
                            <span v-else><small>
                                {{
                                  Math.abs(tr.detail[indextrr].prix)
                                    .toFixed(2)
                                    .toLocaleString()
                                }}
                                EUR + {{
                                  getVatStr(tr.detail[indextrr].subject_vat, tr.detail[indextrr].country_code)
                                }}<br />
                                {{
                                  Math.abs(tr.detail[indextrr].prix * getVat(tr.detail[indextrr].subject_vat,
                                    tr.detail[indextrr].country_code))
                                    .toFixed(2)
                                    .toLocaleString()
                                }} EUR incl. VAT</small>
                            </span>
                          </span>
                        </vs-td>
                        <vs-td style="width: 200px">

                          <vs-button v-if="!readOnly" style="font-size: 11px" class="w-full" @click="openThePopupSendMail(tr.detail[indextrr].mailtoclientsent, trr)
                            " :color="getSendMailColor(tr.detail[indextrr].mailtoclientsent)
                              " icon-pack="feather" icon="icon-mail">Send Invoice<br />
                            <span v-if="tr.detail[indextrr].mailtoclientsent">
                              OK: {{
                                tr.detail[indextrr].date_mailtoclientsent,
                              }}</span>
                            <span v-else>
                              Not sent!
                            </span>

                          </vs-button>
                          <!-- Repere les factures dont le lien adresse a ete
                               perdu, sans avoir a ouvrir chaque popup. -->
                          <div v-if="!isUsableAddress(tr.detail[indextrr])" class="mt-1 text-center"
                            style="font-size: 10px; color: rgba(var(--vs-warning), 1);">
                            <feather-icon icon="AlertTriangleIcon" svgClasses="h-3 w-3" /> adresse manquante
                          </div>
                        </vs-td>
                        <vs-td style="width: 200px" v-if="tr.detail[indextrr]
                          .idinvoicemajoration != -1">
                          <vs-button v-if="!readOnly" style="font-size: 11px" class="w-full" @click="openThePopup(
                            tr.detail[indextrr].paymentreminders,
                            1,
                            trr
                          )
                            " :color="getReminderStatusColor(
                              tr.detail[indextrr].paymentreminders,
                              1
                            )
                              " icon-pack="feather" icon="icon-mail">Reminder 1<br />
                            {{
                              getReminderStatus(
                                tr.detail[indextrr].paymentreminders,
                                1
                              )
                            }}
                          </vs-button>
                          <br />
                          <vs-button style="font-size: 11px" v-if="!readOnly && (getReminderStatus(
                            tr.detail[indextrr].paymentreminders,
                            2
                          ) !== 'Not sent! ') // BUGGGGGGGG
                          " class="w-full" @click="openThePopup(
                            tr.detail[indextrr].paymentreminders,
                            2,
                            trr
                          )
                            " :color="getReminderStatusColor(
                              tr.detail[indextrr].paymentreminders,
                              2
                            )
                              " icon-pack="feather" icon="icon-mail">Reminder 2<br />
                            {{
                              getReminderStatus(
                                tr.detail[indextrr].paymentreminders,
                                2
                              )
                            }}
                          </vs-button>
                          <br />
                          <vs-button style="font-size: 11px" v-if="!readOnly && (getReminderStatus(
                            tr.detail[indextrr].paymentreminders,
                            3
                          ) !== 'Not sent! ') // BUGGGGGGGG
                          " class="w-full" @click="openThePopup(
                            tr.detail[indextrr].paymentreminders,
                            3,
                            trr
                          )
                            " :color="getReminderStatusColor(
                              tr.detail[indextrr].paymentreminders,
                              3
                            )
                              " icon-pack="feather" icon="icon-mail">Reminder 3<br />
                            {{
                              getReminderStatus(
                                tr.detail[indextrr].paymentreminders,
                                3
                              )
                            }}
                          </vs-button>
                          <br />
                          <vs-button v-if="!readOnly && tr.country_code !== 'RO'" style="font-size: 11px" class="w-full" @click="openThePopupSendMailMajoration(tr.detail[indextrr].finalpaymentremindersent, trr)
                            " :color="getSendMailColor(tr.detail[indextrr].finalpaymentremindersent)
                              " icon-pack="feather" icon="icon-mail">
                            <span v-if="tr.detail[indextrr].finalpaymentremindersent">
                              Majoration Sent: {{
                                tr.detail[indextrr].date_finalpaymentremindersent,
                              }}</span>
                            <span v-else-if="tr.detail[indextrr].idinvoicemajoration">
                              Send Majoration Invoice (+12%)
                            </span>
                            <span v-else>
                              Create Majoration Invoice (+12%)
                            </span>
                          </vs-button>
                        </vs-td>
                        <vs-td>
                          <vs-button v-if="!readOnly" style="font-size: 11px" class="w-full" color="danger" type="border"
                            icon-pack="feather" icon="icon-check" @click="openThePopupPartially(trr)">Partially
                            Paid?</vs-button>
                        </vs-td>
                        <vs-td>
                          <vs-button v-if="!readOnly" style="font-size: 11px" class="w-full" color="success" type="border"
                            icon-pack="feather" icon="icon-check" @click="confirmthechangeofthestatus(
                              tr.detail[indextrr].id, null
                            )
                              ">Paid?</vs-button>
                        </vs-td>
                        <vs-td>
                          <vs-button style="font-size: 11px" class="w-full" color="warning" type="border"
                            icon-pack="feather" icon="icon-check" @click="getClientClick(tr.detail[indextrr].id)">View
                            Document Download</vs-button>
                        </vs-td>
                      </vs-tr>
                    </vs-table>
                    <div></div>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>

      <vs-popup fullscreen class="holamundo" title="Send Email" :active.sync="popupActive">
        <div class="my-4">
          <b>Client Name</b>&nbsp;&nbsp;&nbsp;{{ se_user_name }}
        </div>
        <div class="my-4">
          <b>Client Email</b>&nbsp;&nbsp;&nbsp; <span style="width: 400px;">
            <v-select :options="data_options_mail" v-model="datamail" @input="emailSelected" multiple label="email" :reduce="o => o.email">
              <template #option="{ email, source }">
                <span>{{ email }}</span>
                <vs-chip :color="sourceChipColor(source)" size="small" class="ml-2">{{ sourceChipLabel(source) }}</vs-chip>
              </template>
            </v-select>
          </span>
        </div>
        <!--<div class="my-4">
          <b>Client Email</b>&nbsp;&nbsp;&nbsp;{{ se_user_email }}/
        </div>-->
        <div class="my-4">
          <b>Date of Payment</b>&nbsp;&nbsp;&nbsp;{{ se_date }}
        </div>
        <div class="my-4">
          <b>Invoice No</b>&nbsp;&nbsp;&nbsp;{{ se_facture_no }}
        </div>
        <div class="my-4">
          <b>Invoice Reference</b>&nbsp;&nbsp;&nbsp;#{{ se_invoice_id }}
        </div>
        <div class="my-4" v-if="se_invoice_pdf_url">
          <b>Invoice PDF</b>&nbsp;&nbsp;&nbsp;
          <a :href="se_invoice_pdf_url" target="_blank" style="color: #007bff; text-decoration: underline;">
            View the PDF ({{ se_invoice_pdf_filename || 'invoice.pdf' }})
          </a>
        </div>
        <!-- Adresse qui partira dans le mail + sa provenance : sans ca, une
             adresse perdue sur la facture passait inapercue jusqu'au client. -->
        <div class="my-4" v-if="se_whichone === 'Send invoice to client'">
          <template v-if="hasDeliveryAddress()">
            <b>Delivery Address</b>&nbsp;&nbsp;&nbsp;{{ formatDeliveryAddress(se_language, se_delivery_address) }}
            <span v-if="se_delivery_address_source && se_delivery_address_source !== 'operation_delivery'"
              class="ml-2 px-2 py-1 rounded"
              style="background: rgba(var(--vs-warning), .15); font-size: 11px;">
              Taken from the {{ deliveryAddressSourceLabel() }} — please fix it on the invoice
            </span>
          </template>
          <div v-else class="p-3 rounded"
            style="background: rgba(var(--vs-danger), .08); border: 1px solid rgba(var(--vs-danger), .35);">
            <b>Delivery address not found</b><br />
            No address is linked to this invoice, nor to its original quotation, nor to the client.
            The invoice e-mail quotes the delivery address, so it cannot be sent like this.
          </div>
        </div>
        <div class="my-4">
          <b>Overdue Amount</b>&nbsp;&nbsp;&nbsp;{{ se_montant }} EUR
        </div>
        <div class="my-4">
          <b>Email Template</b>&nbsp;&nbsp;&nbsp;{{ se_language }} /
          {{ se_whichone }}
        </div>
        <div class="my-4">
          <b>Mail Object</b>&nbsp;&nbsp;&nbsp;{{ se_title }}
        </div>
        <div class="my-4" style="background-color:#eee;">
          <b>Mail Content</b>&nbsp;&nbsp;&nbsp;<span v-html="se_content"></span>
          <span v-if="se_signature" v-html="se_signature"></span>
        </div>

        <!-- Pourquoi ce mail ne peut pas partir : encadré permanent, en anglais,
             affiché avant même le premier clic. Voir src/views/DashboardFinance.vue. -->
        <div v-if="sendIssuesChecking" class="my-4" style="font-size: 12px; opacity: .7;">
          Checking this e-mail (recipient, attached PDF, amounts)…
        </div>
        <div v-if="sendIssues.blockers.length" class="my-4 p-4 rounded"
          style="background: rgba(var(--vs-danger), .08); border: 1px solid rgba(var(--vs-danger), .45);">
          <div style="font-weight: 600; color: rgba(var(--vs-danger), 1);">
            <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4 align-text-bottom" />
            This e-mail cannot be sent — {{ sendIssues.blockers.length }} problem<span v-if="sendIssues.blockers.length > 1">s</span> to fix
          </div>
          <div v-for="issue in sendIssues.blockers" :key="issue.code" class="mt-3">
            <b>{{ issue.title }}</b><br />
            <span>{{ issue.detail }}</span><br />
            <span style="font-style: italic;">What to do: {{ issue.fix }}</span>
            <a v-if="issue.action" href="#" class="ml-2"
              style="color: #007bff; text-decoration: underline;"
              @click.prevent="issue.action()">{{ issue.actionLabel }}</a>
          </div>
        </div>
        <div v-if="sendIssues.warnings.length" class="my-4 p-4 rounded"
          style="background: rgba(var(--vs-warning), .10); border: 1px solid rgba(var(--vs-warning), .45);">
          <div style="font-weight: 600;">
            Check before sending — this does not block the e-mail
          </div>
          <div v-for="issue in sendIssues.warnings" :key="issue.code" class="mt-3">
            <b>{{ issue.title }}</b><br />
            <span>{{ issue.detail }}</span><br />
            <span style="font-style: italic;">{{ issue.fix }}</span>
            <a v-if="issue.action" href="#" class="ml-2"
              style="color: #007bff; text-decoration: underline;"
              @click.prevent="issue.action()">{{ issue.actionLabel }}</a>
          </div>
        </div>
        <div v-if="sendFailure" class="my-4 p-4 rounded"
          style="background: rgba(var(--vs-danger), .08); border: 1px solid rgba(var(--vs-danger), .45);">
          <div style="font-weight: 600; color: rgba(var(--vs-danger), 1);">
            <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4 align-text-bottom" />
            Last attempt failed — nothing was sent to the client
          </div>
          <div class="mt-2">{{ sendFailure.context }}.</div>
          <div class="mt-2" style="font-size: 11px; opacity: .8;">Technical detail: {{ sendFailure.technical }}</div>
        </div>
        <div v-if="!buttonisshow && se_whichone" class="my-4 p-3 rounded"
          style="background: rgba(var(--vs-primary), .08); border: 1px solid rgba(var(--vs-primary), .35);">
          This document has already been e-mailed to the client. You can send it again with the button below.
        </div>

        <vs-button
          v-if="se_whichone && (se_whichone).toString().toLowerCase().includes('reminder 4')"
          class="w-full" @click="sendEmailMajoration()" icon-pack="feather" icon="icon-send">SEND MAJORATION TO
          CLIENT<br /><span v-if="se_brokermail">(CC Ferdinand,Sales,Mariania + {{ se_broker }} / REPLY TO Mariana + {{ se_brokermail }})</span>
          <span v-else>(CC Ferdinand,Sales,Mariana /
          Reply to Ferdinand,Sales,Mariana)</span>
        </vs-button>
        <vs-button
          v-else-if="se_whichone && (se_whichone).toString().toLowerCase().includes('reminder')"
          class="w-full" @click="sendEmailReminder()" icon-pack="feather" icon="icon-send">SEND REMINDER TO
          CLIENT<br /><span v-if="se_brokermail">(CC Ferdinand,Sales,Mariania + {{ se_broker }} / REPLY TO Mariana + {{ se_brokermail }})</span>
          <span v-else>(CC Ferdinand,Sales,Mariana /
          Reply to Ferdinand,Sales,Mariana)</span>
        </vs-button>
        <vs-button
          v-if="se_whichone && (se_whichone).toString().toLowerCase().includes('invoice')"
          class="w-full" @click="sendEmailInvoice()" icon-pack="feather" icon="icon-send">SEND INVOICE TO
          CLIENT<br /><span v-if="se_brokermail">(CC Ferdinand,Sales,Mariania + {{ se_broker }} / REPLY TO Mariana + {{ se_brokermail }})</span>
          <span v-else>(CC Ferdinand,Sales,Mariana /
          Reply to Ferdinand,Sales,Mariana)</span>
        </vs-button>
        <vs-button
          v-if="se_whichone && (se_whichone).toString().toLowerCase().includes('advance')"
          class="w-full" @click="sendEmailInvoiceAdvance()" icon-pack="feather" icon="icon-send">SEND ADVANCE TO
          CLIENT<br /><span v-if="se_brokermail">(CC Ferdinand,Sales,Mariania + {{ se_broker }} / REPLY TO Mariana + {{ se_brokermail }})</span>
          <span v-else>(CC Ferdinand,Sales,Mariana /
          Reply to Ferdinand,Sales,Mariana)</span>
        </vs-button>
        <vs-button
          v-if="se_whichone && (se_whichone).toString().toLowerCase().includes('note')"
          class="w-full" @click="sendEmailInvoiceCredit()" icon-pack="feather" icon="icon-send">SEND CREDIT NOTE TO
          CLIENT<br /><span v-if="se_brokermail">(CC Ferdinand,Sales,Mariania + {{ se_broker }} / REPLY TO Mariana + {{ se_brokermail }})</span>
          <span v-else>(CC Ferdinand,Sales,Mariana /
          Reply to Ferdinand,Sales,Mariana)</span>
        </vs-button>
        <div class="my-4" v-if="direct_answer_from_the_server">
          <b>Server Answer : </b>
          {{ direct_answer_from_the_server }}
        </div>
      </vs-popup>

      <vs-popup fullscreen class="holamundo" title="Create +12% Invoice"
        :active.sync="popupActiveCreateMajorationInvoice">
        In order to send the email, we need to create an additional invoice with a 12% surcharge. Please confirm the
        creation of the majoration invoice.
        <!--
        const invoice_no = req.params.invoice_no;
        const invoice_no_new = req.params.invoice_no_new;
        const idoperationfrom = req.params.idoperationfrom;
        const tva = req.params.tva;
        const topayeuro = req.params.topayeuro;
        const topayron = req.params.topayron;
        const producttitle = req.params.producttitle;
    -->
        <div class="my-4">
          <b>Client Name</b>&nbsp;&nbsp;&nbsp;{{ se_user_name }}
        </div>
        <div class="my-4">
          <b>Base Invoice No</b>&nbsp;&nbsp;&nbsp;{{ se_facture_no }}
        </div>
        <div class="my-4">
          <b>Base Invoice Reference</b>&nbsp;&nbsp;&nbsp;#{{ se_invoice_id }}
        </div>
        <div class="my-4">
          <b>New Majoration Invoice No</b>&nbsp;&nbsp;&nbsp;{{ this.dataNextInvoiceNr }}
        </div>
        <div class="my-4">
          <b>VAT (%)</b>&nbsp;&nbsp;&nbsp;{{ this.se_tva }}
        </div>
        <div class="my-4">
          <b>Overdue Amount Excl. VAT</b>&nbsp;&nbsp;&nbsp;{{ se_montant }} EUR
        </div>
        <div class="my-4">
          <b>12% Amount Excl. VAT</b>&nbsp;&nbsp;&nbsp;{{ parseFloat((se_montant) / 100 * 12).toFixed(2) }} EUR
        </div>
        <div class="my-4">
          <b>Language</b>&nbsp;&nbsp;&nbsp;{{ se_language }}
        </div>
        <div class="my-4">
          <b>Product Title</b>&nbsp;&nbsp;&nbsp;{{ getProductName(se_language) }}
        </div>
        <vs-button v-if="se_whichone" class="w-full" @click="createMajorationInvoice()" icon-pack="feather"
          icon="icon-check">
          Confirm Create Majoration Invoice
        </vs-button>
      </vs-popup>


      <vs-popup class="holamundo" title="Partially Paid" :active.sync="popupActivePartiallyPaid">
        <div class="my-4">
          <b>Client Name</b>&nbsp;&nbsp;&nbsp;{{ se_user_name }}
        </div>
        <div class="my-4">
          <b>Invoice No</b>&nbsp;&nbsp;&nbsp;{{ se_facture_no }}
        </div>
        <div class="my-4">
          <b>Invoice Reference</b>&nbsp;&nbsp;&nbsp;#{{ se_invoice_id }}
        </div>
        <div class="my-4">
          <b>Total Amount</b>&nbsp;&nbsp;&nbsp;{{ se_montant }} EUR
        </div>
        <div class="my-4">
          <b></b>&nbsp;&nbsp;&nbsp;
          <vs-input label="Amount Partially Paid (EUR)" v-model="dataAmountPartiallyPaid" class="mt-4 w-1/3"
            name="name" />
        </div>

        <vs-button class="w-full" @click="updatePartiallyPaidAmount(se_invoice_id)" icon-pack="feather"
          icon="icon-send">Adjust Amount Partially Paid
        </vs-button>
      </vs-popup>
    </div>
    <!-- Trans EUR -->
    <vs-popup title="Transactions EUR" :active.sync="popupActiveEur">
      <div v-if="transactionsEur && transactionsEur.length > 0">
        <div class="vx-row w-12/12">
          <div class="vx-col lg:w-4/12 w-4/12">
            <vs-select autocomplete v-model="dataIdClient" label="Client" class="mt-0 lg:w-full w-full"
              name="client_id">
              <vs-select-item v-for="client in unpaid_invoice" :key="client.clientid" :value="client.clientid"
                :text="client.client" />
            </vs-select>
          </div>
          <div class="vx-col lg:w-4/12 w-4/12">
            <vs-select autocomplete v-model="dataIdInvoicePaid"
              @input="setTotalAndPartially(filteredInvoices, dataIdInvoicePaid, 'EUR')" label="Invoice Nr"
              class="mt-0 lg:w-full w-full" name="invoice_no">
              <vs-select-item v-for="invoice in filteredInvoices" :key="invoice.id" :value="invoice.id"
                :text="invoice.invoice_no" />
            </vs-select>
          </div>
          <div class="vx-col lg:w-4/12 w-4/12 mt-0">
            <vs-input v-if="dataIdInvoicePaid" label="+ Partially Paid (EUR)" v-model="dataAmountPartiallyPaidPopupEur"
              class="w-full lg:w-full" name="name" v-validate="'required'" />
          </div>
        </div>

        <div class="vx-row">

          <div class="vx-col lg:w-full w-full mt-2" style="float:right;text-align:right">
            <span v-if="alreadyPaidPopupEur && dataAmountPartiallyPaidPopupEur">Paid : {{ alreadyPaidPopupEur }}EUR + {{
              dataAmountPartiallyPaidPopupEur }}EUR / {{ totalInvoiceToBePaidPopupEur }}EUR (REST {{
                (totalInvoiceToBePaidPopupEur) - (parseFloat(alreadyPaidPopupEur) +
                  parseFloat(dataAmountPartiallyPaidPopupEur)).toFixed(2)
              }}EUR)</span>
            <span v-else-if="alreadyPaidPopupEur">Paid : {{ alreadyPaidPopupEur }}EUR / {{ totalInvoiceToBePaidPopupEur
              }}EUR (REST {{ ((totalInvoiceToBePaidPopupEur) - (parseFloat(alreadyPaidPopupEur))).toFixed(2)
              }}EUR)</span>
            <span v-else-if="totalInvoiceToBePaidPopupEur">Total to be paid : {{ totalInvoiceToBePaidPopupEur
              }}EUR</span>

            <vs-button style="width:100%" class="w-full mt-1" type="border" color="success" icon-pack="feather"
              icon="icon-check" @click="confirmthechangeofthestatus(dataIdInvoicePaid, null)"
              v-if="dataIdInvoicePaid && !dataAmountPartiallyPaidPopupEur || ((totalInvoiceToBePaidPopupEur) - (parseFloat(alreadyPaidPopupEur) + parseFloat(dataAmountPartiallyPaidPopupEur)) == 0)">Totally
              Paid</vs-button>
            <vs-button class="w-full" color="success" type="border" icon-pack="feather" icon="icon-check"
              @click="updatePartiallyPaidAmount(dataIdInvoicePaid)" v-else-if="dataIdInvoicePaid">Partially
              Paid</vs-button>
          </div>
        </div>

        <hr class="mt-4 mb-4" style="border: 1px dashed #c0c0c0;">

        <div v-for="(mx, index) in transactionsEur" :key="index" class="institution">
          <div class="institution-info">
            <div class="header">
              <h2 style="color:#518b92">#{{ index + 1 }} - {{ mx.gcl_bookingdate }}</h2>
              <img :src="mx.gcl_logo" alt="graphic">
            </div>
            <div class="mt-0">
              <p>- <b>Amount</b> {{ mx.gcl_amount }} EUR <feather-icon class="sm:inline-flex cursor-pointer p-2"
                  style="width: 30px;" icon="CopyIcon" @click.stop="copyToAmount(mx.gcl_amount)" /></p>
              <p>- <b>Description</b> {{ mx.gcl_comment }}</p>

            </div>
            <vs-button style="font-size: 11px" class="w-full mt-4" color="warning" icon-pack="feather" type="border"
              icon="icon-delete" @click="confirmthechangeofthestatus(25183, mx.idtrans)">
              Remove from List
            </vs-button>
          </div>
          <!--<vs-button type="border" class="vs-button" @click="connectAccount(account.account.id)">Connect</vs-button>-->
        </div>
        <div>
        </div>
      </div>
      <div v-else>
        <h3 style="text-align:center">No Transactions</h3>
      </div>
    </vs-popup>
    <!-- Trans RON -->
    <vs-popup title="Transactions RON" :active.sync="popupActiveRon">
      <div v-if="transactionsRon && transactionsRon.length > 0">
        <div class="vx-row w-12/12">
          <div class="vx-col lg:w-4/12 w-4/12">
            <vs-select autocomplete v-model="dataIdClient" label="Client" class="mt-0 lg:w-full w-full"
              name="client_id">
              <vs-select-item v-for="client in unpaid_invoice" :key="client.clientid" :value="client.clientid"
                :text="client.client" />
            </vs-select>
          </div>
          <div class="vx-col lg:w-4/12 w-4/12">
            <vs-select autocomplete v-model="dataIdInvoicePaid"
              @input="setTotalAndPartially(filteredInvoices, dataIdInvoicePaid, 'RON')" label="Invoice Nr"
              class="mt-0 lg:w-full w-full" name="invoice_no">
              <vs-select-item v-for="invoice in filteredInvoices" :key="invoice.id" :value="invoice.id"
                :text="invoice.invoice_no" />
            </vs-select>
          </div>
          <div class="vx-col lg:w-4/12 w-4/12 mt-0">
            <vs-input v-if="dataIdInvoicePaid" label="+ Partially Paid (RON)" v-model="dataAmountPartiallyPaidPopupEur"
              class="w-full lg:w-full" name="name" v-validate="'required'" />
          </div>
        </div>
        <div class="vx-row">

          <div class="vx-col lg:w-full w-full mt-2" style="float:right;text-align:right">
            <span v-if="alreadyPaidPopupEur && dataAmountPartiallyPaidPopupEur">Paid : {{ alreadyPaidPopupEur }}RON + {{
              dataAmountPartiallyPaidPopupEur }}RON / {{ totalInvoiceToBePaidPopupEur }}RON (REST {{
                (totalInvoiceToBePaidPopupEur) - (parseFloat(alreadyPaidPopupEur) +
                  parseFloat(dataAmountPartiallyPaidPopupEur))
              }}RON)</span>
            <span v-else-if="alreadyPaidPopupEur">Paid : {{ alreadyPaidPopupEur }}RON / {{ totalInvoiceToBePaidPopupEur
              }}RON (REST {{ (totalInvoiceToBePaidPopupEur) - (parseFloat(alreadyPaidPopupEur)) }}RON)</span>
            <span v-else-if="totalInvoiceToBePaidPopupEur">Total to be paid : {{ totalInvoiceToBePaidPopupEur
              }}RON</span>

            <vs-button style="width:100%" class="w-full mt-1" type="border" color="success" icon-pack="feather"
              icon="icon-check" @click="confirmthechangeofthestatus(dataIdInvoicePaid, null)"
              v-if="dataIdInvoicePaid && !dataAmountPartiallyPaidPopupEur || ((totalInvoiceToBePaidPopupEur) - (parseFloat(alreadyPaidPopupEur) + parseFloat(dataAmountPartiallyPaidPopupEur)) == 0)">Totally
              Paid</vs-button>
            <vs-button class="w-full" color="success" type="border" icon-pack="feather" icon="icon-check"
              @click="updatePartiallyPaidAmount(dataIdInvoicePaid)" v-else-if="dataIdInvoicePaid">Partially
              Paid</vs-button>
          </div>
        </div>

        <hr class="mt-4 mb-4" style="border: 1px dashed #c0c0c0;">
        <div v-for="(mx, index) in transactionsRon" :key="index" class="institution">
          <div class="institution-info">
            <div class="header">
              <h2 style="color:#518b92">#{{ index + 1 }} - {{ mx.gcl_bookingdate }}</h2>
              <img :src="mx.gcl_logo" alt="graphic">
            </div>
            <div class="mt-0">
              <p>- <b>Amount</b> {{ mx.gcl_amount }} RON <feather-icon class="sm:inline-flex cursor-pointer p-2"
                  style="width: 30px;" icon="CopyIcon" @click.stop="copyToAmount(mx.gcl_amount)" /></p>
              <p>- <b>Description</b> {{ mx.gcl_comment }}</p>
            </div>

            <vs-button style="font-size: 11px" class="w-full mt-4" color="warning" icon-pack="feather" type="border"
              icon="icon-delete" @click="confirmthechangeofthestatus(25183, mx.idtrans)">
              Remove from List
            </vs-button>
          </div>
          <!--<vs-button type="border" class="vs-button" @click="connectAccount(account.account.id)">Connect</vs-button>-->
        </div>
        <div>
        </div>
      </div>
      <div v-else>
        <h3 style="text-align:center">No Transactions</h3>
      </div>
    </vs-popup>
    <!-- New Account -->
    <vs-popup title="Transactions matching unpaid invoices" :active.sync="popupActiveAccount">
      <div v-if="matchingbank && matchingbank.length > 0">
        <div v-for="(mb, index) in matchingbank" :key="index" class="institution">
          <div class="institution-info">
            <div class="header">
              <h2 style="color:#518b92">#{{ index + 1 }} - {{ mb.matchtype }}</h2>
              <img :src="mb.transaction[0].gcl_logo" alt="graphic">
            </div>
            <div class="mt-4">
              <h4 class="mb-2" style="color:#185c63">Transaction</h4>
              <p>- <b>Date</b> {{ mb.transaction[0].date }}</p>
              <p>- <b>Iban</b> {{ mb.transaction[0].gcl_iban }}</p>
              <p>- <b>Amount</b> {{ mb.transaction[0].gcl_amount }}</p>
              <p>- <b>Description</b> {{ mb.transaction[0].gcl_comment }}</p>
            </div>
            <div class="mt-4">
              <h4 class="mb-2" style="color:#185c63">Invoice</h4>
              <p>- <b>Number</b> {{ mb.sale.invoice_no }}</p>
              <p>- <b>Due Date</b> {{ mb.sale.the_date }}</p>
              <p>- <b>Amount</b> {{ mb.sale.prix }}</p>
              <p>- <b>Client</b> {{ mb.sale.client }}</p>
            </div>
            <vs-button style="font-size: 11px" class="w-full mt-4" color="success" icon-pack="feather" icon="icon-check"
              @click="confirmthechangeofthestatus(mb.sale.id, mb.transaction[0].id)">
              Paid?
            </vs-button>
          </div>
          <!--<vs-button type="border" class="vs-button" @click="connectAccount(account.account.id)">Connect</vs-button>-->
        </div>
        <div>
        </div>
      </div>
      <div v-else>
        <h3 style="text-align:center">No Match</h3>
      </div>
    </vs-popup>
    <vs-popup title="Client Click" :active.sync="popupActiveClientClick">
      <div v-if="clientclick && clientclick.length > 0">
        <div v-for="(mb, index) in clientclick" :key="index" class="institution">
          <div class="institution-info">
            <div class="mt-4">
              <p><b>Description</b> {{ mb.description }}</p>
            </div>
            <div class="mt-4">
              <h4 class="mb-2" style="color:#185c63">Details</h4>
              <p>- <b>IP</b> {{ mb.ip }}</p>
              <p>- <b>Download Date</b> {{ formattedDate(mb.createdAt) }}</p>
            </div>
          </div>
        </div>
        <div>
        </div>
      </div>
      <div v-else>
        <h3 style="text-align:center">No download</h3>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import vSelect from "vue-select";
//import VueApexCharts from "vue-apexcharts";
import moment from "moment";
const themeColors = ["#1292d7", "#EA5455", "#FF9F43", "#28C76F", "#1E1E1E"];
import axios from "@/axios.js";
import { isReadOnlyUser } from "@/helpers/roleAccess.js";
import moduleDataListDashboard from "@/store/dashboard/moduleOperationList.js";
import { buildRecipientOptions, pickDefaultRecipients, sourceChipColor, sourceChipLabel } from "@/helpers/mail-recipients.js";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      readOnly: isReadOnlyUser(), // compte en lecture seule (Broker Status) : actions masquées
      data_options_mail: [],
      datamail: [],
      popupActiveCreateMajorationInvoice: false,
      se_title: null,
      dataNextInvoiceNr: null,
      popupActiveClientClick: false,
      alreadyPaidPopupEur: null,
      totalInvoiceToBePaidPopupEur: null,
      dataAmountPartiallyPaidPopupEur: null,
      dataIdClient: null,
      dataIdInvoicePaid: null,
      lastPopup: null,
      popupActiveRon: false,
      transactionsRon: [],
      popupActiveEur: false,
      transactionsEur: [],
      popupActiveAccount: false,
      matchingbank: null,
      idpayment: null,
      invoiceispaid: null,
      idtransaction: null,
      direct_answer_from_the_server: null,
      buttonisshow: true,
      se_idmajoration: null,
      se_whichone: null, // first or second recall
      se_user_id: null,
      se_montant: null,
      se_language: null,
      se_object: null,
      se_content: null,
      se_signature: null,
      se_language_id: null,
      se_facture_no: null,
      se_date: null,
      se_tva: null,
      se_invoice_id: null,
      se_user_email: null,
      se_user_name: null,
      se_broker: null,
      se_brokermail: null,
      se_delivery_address: null,
      // Provenance de l'adresse affichee : facture, devis d'origine, client...
      // ou 'none' quand la cascade n'a rien trouve (envoi bloque).
      se_delivery_address_source: null,
      se_invoice_pdf_url: null,
      se_invoice_pdf_filename: null,
      // Pourquoi ce mail ne part pas — même encadré explicatif que l'écran
      // Overdue interne (src/views/DashboardFinance.vue) : plus jamais de
      // bouton qui disparaît ni d'envoi refusé sans motif affiché.
      sendIssues: { blockers: [], warnings: [] },
      sendIssuesChecking: false,
      sendFailure: null,
      // Remaining balance preview data (differences between quotation and invoice)
      previewHasRemainingBalance: false,
      previewChildQuotationId: null,
      previewRemainingProducts: [],
      dataAmountPartiallyPaid: 0,
      popupActivePartiallyPaid: false,
      popupActive: false,
      displayExport: false,
      saleList: [],
      getmailstatus: [],
      evolutionEbitda: {},
      monthlyEbitda: {},
      //isGraphFailed: true,
      valueRevenue: [],
      valueVariable: [],
      valueProfit: [],
      valueFixed: [],
      totalUnpaid: "Unpaid Invoices",
      clientclick: [],
    };
  },
  watch: {
    dataIdClient(newVal, oldVal) {
      // When dataIdClient changes, reset dataIdInvoicePaid
      this.dataIdInvoicePaid = null;
    }
  },
  mounted: function () {
    //this.initGraphiqueCumulated();
  },
  /*components: {
    VueApexCharts,
  },*/
  computed: {
    dashboard_ocol() {
      return this.$store.state.dataListDashboard.dashboardocollist;
    },
    dashboard_ocol_sum() {
      return this.$store.state.dataListDashboard.dashboardocolsum;
    },
    dashboard_finance() {
      return this.$store.state.dataListDashboard.kpi;
    },
    unpaid_invoice() {
      return this.$store.state.dataListDashboard.unpaidinvoice;
    },
    value_unpaid_invoice() {
      let returnedvalue =
        "Overdue payment from customers"
      return returnedvalue;
    },
    unpaid_invoice_provider() {
      return this.$store.state.dataListDashboard.unpaidinvoiceprovider;
    },
    value_unpaid_invoice_ocol() {
      let returnedvalue =
        "Overdue payment from XYLO (OCOL) → " +
        Number(
          this.$store.state.dataListDashboard.dashboardocolsum
        ).toLocaleString() +
        " RON Excluding VAT";
      return returnedvalue;
    },
    value_unpaid_invoice_provider() {
      let returnedvalue =
        "Overdue payment from XYLO (TRANSPORT) → " +
        Number(
          this.$store.state.dataListDashboard.unpaidinvoiceprovidersum
        ).toLocaleString() +
        " EUR Excluding VAT";
      return returnedvalue;
    },
    filteredInvoices() {
      const client = this.unpaid_invoice.find(item => item.clientid === this.dataIdClient);
      return client ? client.detail : [];
    }
  },
  methods: {
    sourceChipColor,
    sourceChipLabel,
    populateEmailOptions(person, kind = 'invoice') {
      const options = buildRecipientOptions(person);
      const defaults = pickDefaultRecipients(options, kind);
      this.data_options_mail = options;
      this.datamail = defaults.map(o => o.email);
      this.se_user_email = this.datamail.join(';');
      // Dernière étape de toutes les ouvertures de popup : le diagnostic
      // s'affiche avant même le premier clic.
      this.refreshSendIssues();
    },
    emailSelected() {
      // Convertir le tableau d'emails en chaîne de caractères séparée par des ;
      const emailsSeparatedBySemicolon = this.datamail.join(';');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // Vérifier que tous les emails sélectionnés sont valides
      const allEmailsValid = this.datamail.every(email => emailRegex.test(email));
      // Afficher ou cacher le bouton d'envoi selon la validité des emails
      this.sendVisible = allEmailsValid;
      // Mettre à jour la valeur utilisée pour l'envoi et l'affichage
      this.se_user_email = emailsSeparatedBySemicolon;
      this.refreshSendIssues();
    },
    openInvoiceTab(idoperation) {
      if (!idoperation) return;
      window.open(`/broker/invoice/${idoperation}`, '_blank');
    },
    /** Rouvre la facture en mode régénération : le PDF est reconstruit et ré-archivé. */
    regenerateArchivedInvoice(idoperation) {
      if (!idoperation) return;
      window.open(`/broker/invoice/${idoperation}?fromEdit=true`, '_blank');
    },
    selectedRecipients() {
      if (Array.isArray(this.datamail)) return this.datamail.filter(Boolean);
      return this.datamail ? [this.datamail] : [];
    },
    async fetchArchivedPdfStatus(idoperation) {
      if (!idoperation) return { unavailable: true, error: 'no invoice id' };
      try {
        const response = await axios.get(`/operation/invoicepdfstatus/${idoperation}`);
        return response.data || {};
      } catch (err) {
        console.error('[overdue] invoice PDF status unavailable', err);
        const detail = (err.response && err.response.status)
          ? `HTTP ${err.response.status}`
          : (err.message || String(err));
        return { unavailable: true, error: detail };
      }
    },
    /**
     * Tout ce qui empêche (ou mérite un avertissement avant) l'envoi, en
     * anglais et avec le remède. Un envoi n'est refusé que si `blockers` n'est
     * pas vide : aucun blocage muet.
     */
    async collectSendIssues() {
      const blockers = [];
      const warnings = [];
      const which = (this.se_whichone && this.se_whichone.toString().toLowerCase()) || '';
      const isInvoiceMail = which.includes('invoice') && !which.includes('reminder');
      const isReminder = which.includes('reminder');
      const step = this.extractNumber(this.se_whichone);

      if (!this.selectedRecipients().length) {
        blockers.push({
          code: 'no-recipient',
          title: 'No recipient selected',
          detail: this.data_options_mail && this.data_options_mail.length
            ? 'This client has e-mail addresses on file, but none is selected in the "Client Email" field above.'
            : 'No e-mail address is recorded for this client, so there is nobody to send this message to.',
          fix: this.data_options_mail && this.data_options_mail.length
            ? 'Pick at least one address in the "Client Email" field above.'
            : 'Add an e-mail address on the client sheet, then reopen this pop-up.'
        });
      }

      if (isReminder && !(step >= 1 && step <= 4)) {
        blockers.push({
          code: 'unknown-step',
          title: 'Reminder step not recognised',
          detail: `The pop-up was opened as "${this.se_whichone}", which does not match reminder 1, 2, 3 or 4. The subject and body of the e-mail cannot be built.`,
          fix: 'Close this pop-up and reload the page, then open the reminder again.'
        });
      }
      if (!isReminder && !isInvoiceMail && !which.includes('advance') && !which.includes('note')) {
        blockers.push({
          code: 'unknown-template',
          title: 'E-mail template not recognised',
          detail: `The pop-up was opened as "${this.se_whichone || '(empty)'}", which matches no known template.`,
          fix: 'Close this pop-up and reload the page.'
        });
      }

      if (isInvoiceMail && !this.hasDeliveryAddress()) {
        blockers.push({
          code: 'no-address',
          title: 'Delivery address missing',
          detail: 'The invoice e-mail states the delivery address, and none was found — not on the invoice, not on the original quotation, not on the client sheet. Sending now would produce a mail with an empty address.',
          fix: 'Open the invoice and fill in the delivery address, then reopen this pop-up.',
          actionLabel: 'Open the invoice',
          action: () => this.openInvoiceTab(this.se_invoice_id)
        });
      }

      if (!this.se_invoice_pdf_url) {
        blockers.push({
          code: 'no-pdf-link',
          title: 'No invoice PDF attached to this invoice',
          detail: 'This invoice has never been saved as a PDF on the server, so there is nothing to attach. The e-mail is never sent without its invoice copy.',
          fix: 'Open the invoice and generate the PDF — it is archived automatically — then reopen this pop-up.',
          actionLabel: 'Generate the PDF now',
          action: () => this.regenerateArchivedInvoice(this.se_invoice_id)
        });
      } else {
        const status = await this.fetchArchivedPdfStatus(this.se_invoice_id);
        if (status.unavailable) {
          blockers.push({
            code: 'pdf-check-failed',
            title: 'The attached PDF could not be checked',
            detail: `The server did not answer the amount check for the archived PDF (${status.error}). We do not send an invoice copy we could not verify.`,
            fix: 'Try again in a moment. If it keeps failing, the API is down — warn the IT support.'
          });
        } else if (status.stale && !status.hasPdf) {
          blockers.push({
            code: 'pdf-file-missing',
            title: 'The archived PDF file is missing on the server',
            detail: 'The invoice points to a PDF that no longer exists in the server storage, so the attachment cannot be built.',
            fix: 'Regenerate the invoice PDF, then send again.',
            actionLabel: 'Regenerate the PDF',
            action: () => this.regenerateArchivedInvoice(this.se_invoice_id)
          });
        } else if (status.stale) {
          const changed = (status.changedFields || [])
            .map(c => `${c.field}: ${c.before} → ${c.now}`)
            .join(' · ');
          blockers.push({
            code: 'pdf-outdated',
            title: 'The archived PDF no longer matches the invoice',
            detail: `The invoice was modified after this PDF was generated: ${changed || 'the totals differ'}. Sending it would deliver the old amounts to the client.`,
            fix: 'Regenerate the invoice PDF (one click below), then send again.',
            actionLabel: 'Regenerate the PDF',
            action: () => this.regenerateArchivedInvoice(this.se_invoice_id)
          });
        } else if (status.unverified) {
          warnings.push({
            code: 'pdf-unverified',
            title: 'Attached PDF not verified',
            detail: 'This PDF was archived before the amount check existed, so its totals could not be compared with the invoice. The e-mail can be sent.',
            fix: 'If in doubt, regenerate the PDF before sending.',
            actionLabel: 'Regenerate the PDF',
            action: () => this.regenerateArchivedInvoice(this.se_invoice_id)
          });
        }
      }

      if (isInvoiceMail && this.hasDeliveryAddress() &&
          this.se_delivery_address_source && this.se_delivery_address_source !== 'operation_delivery') {
        warnings.push({
          code: 'address-fallback',
          title: 'Delivery address taken from another document',
          detail: `The invoice itself carries no delivery address; the one shown above comes from the ${this.deliveryAddressSourceLabel()}.`,
          fix: 'Check it, and fix the invoice if it is wrong.',
          actionLabel: 'Open the invoice',
          action: () => this.openInvoiceTab(this.se_invoice_id)
        });
      }

      return { blockers, warnings };
    },
    async refreshSendIssues() {
      this.sendIssuesChecking = true;
      try {
        this.sendIssues = await this.collectSendIssues();
      } catch (err) {
        console.error('[overdue] send diagnostics failed', err);
        const failure = {
          code: 'diagnostics-failed',
          title: 'Pre-send checks could not run',
          detail: `Unexpected error while checking this e-mail: ${err.message || String(err)}.`,
          fix: 'Reload the page and try again; warn the IT support if it persists.'
        };
        this.sendIssues = { blockers: [failure], warnings: [] };
      } finally {
        this.sendIssuesChecking = false;
      }
      return this.sendIssues;
    },
    async guardBeforeSend() {
      this.sendFailure = null;
      const { blockers } = await this.refreshSendIssues();
      if (!blockers.length) return true;
      this.$vs.notify({
        color: 'danger',
        title: blockers.length > 1 ? `E-mail not sent — ${blockers.length} problems` : 'E-mail not sent',
        text: `${blockers[0].title}. ${blockers[0].fix} See the red box in this window for the full explanation.`,
        iconPack: 'feather',
        icon: 'icon-alert-triangle',
        position: 'top-center',
        time: 15000
      });
      return false;
    },
    reportSendFailure(context, error) {
      const payload = error && error.response ? error.response.data : null;
      let technical = (error && error.message) || String(error || 'unknown error');
      if (typeof payload === 'string' && payload) technical = payload;
      else if (payload) technical = payload.message || payload.text || JSON.stringify(payload);
      else if (error && error.response && error.response.status) technical = `HTTP ${error.response.status}`;
      console.error(`[overdue] ${context}`, error);
      this.sendFailure = { context, technical };
      this.direct_answer_from_the_server = technical;
      this.$vs.notify({
        color: 'danger',
        title: 'E-mail not sent',
        text: `${context} — ${technical}`,
        iconPack: 'feather',
        icon: 'icon-alert-triangle',
        position: 'top-center',
        time: 15000
      });
    },
    async fetchInvoicePdfBase64(pdfUrl) {
      const response = await axios.get(pdfUrl, { responseType: 'arraybuffer' });
      const bytes = new Uint8Array(response.data);
      let binary = '';
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    },
    createMajorationInvoice() {
      //alert( "/operation/generatemajorationfromunpaidinvoice/"+this.se_facture_no+"/"+this.se_invoice_id+"/"+this.dataNextInvoiceNr+"/"+this.getProductName(this.se_language)+"/"+parseFloat((this.se_montant)/100*12).toFixed(2)+"/"+this.se_montant+"/"+this.se_tva)
      axios
        .get(
          "/operation/generatemajorationfromunpaidinvoice/" + this.se_facture_no + "/" + this.se_invoice_id + "/" + this.dataNextInvoiceNr + "/" + this.getProductName(this.se_language) + "/" + parseFloat((this.se_montant) / 100 * 12).toFixed(2) + "/" + this.se_montant + "/" + this.se_tva
        )
        .then((response) => {
          this.popupActiveCreateMajorationInvoice = false
        })
        .then((response) => {
          this.$vs.loading();
          this.$store
            .dispatch("dataListDashboard/fetchTotalValueOfUnpaidInvoice")
            .then((response) => {
              this.$store
                .dispatch("dataListDashboard/fetchListOfUnpaidInvoice")
                .then((response) => {
                  this.$vs.loading.close();
                });
            });
        })
        .catch((error) => { });
    },
    getProductName(language) {
      if (language) {
        if (language.substring(0, 2).toLowerCase() == "fr")
          return "Pénalité pour paiement en retard: facture " + this.se_facture_no;
        else if (language.substring(0, 2).toLowerCase() == "de")
          return "Strafe für verspätete Zahlung: Rechnung " + this.se_facture_no;
        else if (language.substring(0, 2).toLowerCase() == "ro")
          return "Penalizare pentru întârzierea plății: factură " + this.se_facture_no;
        else if (language.substring(0, 2).toLowerCase() == "es")
          return "Penalización por pago tardío: factura " + this.se_facture_no;
        else if (language.substring(0, 2).toLowerCase() == "ne")
          return "Boete voor laattijdige betaling: factuur " + this.se_facture_no;
        else
          return "Late payment penalty: invoice " + this.se_facture_no;
      }
    },
    async getClientClick(idoperation) {
      axios.get("/publicdownloads/data/" + idoperation).then((response) => {
        this.clientclick = response.data;
      }).then(e => {
        this.popupActiveClientClick = true
      });
    },
    copyToAmount(amount) {
      // Le notify rouge etait INCONDITIONNEL : affiche aussi quand la facture
      // etait selectionnee et le montant copie.
      if (!this.dataIdInvoicePaid) {
        this.$vs.notify({
          color: "danger",
          title: "Copy Amount",
          text: "Select an invoice first!",
        });
        return;
      }
      this.dataAmountPartiallyPaidPopupEur = amount
    },
    // Le popup affichait le total BRUT de la facture : l'argent deja rattache
    // par la banque (transactions_operations) n'etait pas deduit, si bien qu'une
    // facture a moitie encaissee s'annoncait due en entier — et le bloc RON
    // affichait le total EUR sous un libelle RON.
    setTotalAndPartially (ListInvoice, idInvoiceSelected, currency) {
      const inv = ListInvoice.find(item => item.id === idInvoiceSelected)
      if (!inv) {
        this.totalInvoiceToBePaidPopupEur = null
        this.alreadyPaidPopupEur = null
        return
      }
      const total = currency === 'RON' ? inv.prix_ron : inv.prix
      const allocated = parseFloat(inv.alreadyallocated || 0)
      const legacy = parseFloat(inv.amountpartiallypaid || 0)
      // allocateTransaction recopie la somme des allocations dans
      // invoice_amount_partially_paid : les additionner compterait le meme
      // encaissement deux fois.
      const paid = Math.max(allocated, legacy)
      this.totalInvoiceToBePaidPopupEur = total
      this.alreadyPaidPopupEur = paid > 0.001 ? paid.toFixed(2) : null
    },
    findTransactionsEUR() {
      this.dataAmountPartiallyPaidPopupEur = null
      this.alreadyPaidPopupEur = null
      this.popupActiveEur = null
      this.dataIdInvoicePaid = null
      this.dataIdClient = null
      this.$store
        .dispatch("dataListDashboard/findTransactionsEur")
        .then(res => {
          console.log(res.data)
          this.transactionsEur = res.data;
          this.popupActiveEur = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    findTransactionsRON() {
      this.$store
        .dispatch("dataListDashboard/findTransactionsRon")
        .then(res => {
          console.log(res.data)
          this.transactionsRon = res.data;
          this.popupActiveRon = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    findMatchingBanksInvoices() {
      this.$store
        .dispatch("dataListDashboard/findMatchingBanksInvoices")
        .then(res => {
          this.matchingbank = res.data;
          this.popupActiveAccount = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    statuschangedOcol() {
      this.$vs.notify({
        color: "success",
        title: "Payment status",
        text: "The invoice has been paid",
      });
    },
    changethestatusOcol() {
      var item = { id: this.idpayment }
      axios
        .post("/paymentschedule/setpaid", {
          item
        })
        .then((response) => {
          this.statuschangedOcol();
        })
        .then((response) => {
          this.$store
            .dispatch("dataListDashboard/fetchDashboardOverdueOcolList")
            .then((response) => {
              this.$store
                .dispatch("dataListDashboard/fetchDashboardOverdueOcolSum")
                .then((response) => {
                  this.$vs.loading.close();
                });
            });
        })
        .catch(() => { });
    },
    confirmthechangeofthestatusOcol(idpayment) {
      this.idpayment = idpayment;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Payment status",
        text: `You are about to set the ocol payment status as paid!`,
        accept: this.changethestatusOcol,
        acceptText: "Yes!",
      });
    },

    formattedDate(ddatte) {
      const dateObj = new Date(ddatte);
      const day = String(dateObj.getUTCDate()).padStart(2, '0');
      const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, so +1 is necessary
      const year = dateObj.getUTCFullYear();

      return `${year}-${month}-${day}`;
    },
    getVat(subject, country_code) {
      if (!country_code) return 'NO BILLING ADDRESS'
      if (country_code === 'RO') return 1.21
      else if (country_code !== 'RO' && subject) return 0
      else {
        if (country_code === 'BE') return 1.21
        else return 1.19
      }
    },
    getVatStr(subject, country_code) {
      if (!country_code) return 'NO BILLING ADDRESS'
      if (country_code === 'RO') return '21%'
      else if (country_code !== 'RO' && subject) return 'N/A'
      else {
        if (country_code === 'BE') return '21%'
        else return '21%'
      }
    },
    updatePartiallyPaidAmount(id) {
      //        this.dataAmountPartiallyPaid
      if (this.dataAmountPartiallyPaidPopupEur && this.alreadyPaidPopupEur) {
        this.dataAmountPartiallyPaid = parseFloat(this.dataAmountPartiallyPaidPopupEur) + parseFloat(this.alreadyPaidPopupEur)
      }
      else if (this.dataAmountPartiallyPaidPopupEur) {
        this.dataAmountPartiallyPaid = parseFloat(this.dataAmountPartiallyPaidPopupEur)
      }
      this.dataAmountPartiallyPaidPopupEur = null
      this.alreadyPaidPopupEur = null
      let obj = {
        idoperation: id,
        amount: this.dataAmountPartiallyPaid
      };
      axios
        .post("/operation/operationpartiallypaid", obj)
        .then((response) => {
          this.popupActivePartiallyPaid = false;
          this.popupActiveEur = false;
          this.$store.dispatch(
            "dataListDashboard/fetchTotalValueOfUnpaidInvoice"
          );
          this.$store.dispatch("dataListDashboard/fetchListOfUnpaidInvoice");
        })
        .catch(() => {
          alert("ERROR");
        });
    },
    async openThePopupPartially(data) {
      await this.fillInTheForm(data, "Reminder 1");
      this.dataAmountPartiallyPaid = data.amountpartiallypaid;
      this.popupActivePartiallyPaid = true;
    },
    getapvurl(id) {
      return "/web/reception/" + id;
    },
    getTransportDirTeiuUrl(id) {
      return "/web/incoming-transport/" + id;
    },
    getTransportUrl(id) {
      return "/web/transport/" + id;
    },
    getInvoiceUrl(id) {
      return "/web/invoice/" + id;
    },
    getClientUrl(id) {
      return "/web/person/" + id;
    },
    insertInDb(responseserver) {
      let obj = {
        sentto: this.se_user_email,
        mailtitle: this.se_language + " / Reminder" + this.se_whichone,
        mailcontent:
          this.se_language +
          " / Reminder" +
          this.extractNumber(this.se_whichone) +
          " / Value:" +
          this.se_montant +
          "EUR",
        date: moment().format("yyyy-MM-DD"),
        responsemailserver: responseserver,
        idperson: this.se_user_id,
        idoperation: this.se_invoice_id,
        idpaymentreminderstatus: this.extractNumber(this.se_whichone),
      };
      axios
        .post("/paymentreminder/newmailsent", obj)
        .then((response) => {
          //this.popupActive = false;
          this.$store.dispatch(
            "dataListDashboard/fetchTotalValueOfUnpaidInvoice"
          );
          this.$store.dispatch("dataListDashboard/fetchListOfUnpaidInvoice");
        })
        .catch(() => {
          alert("ERROR");
        });
    },
    getTitleFirstReminder(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Rappel de paiement: facture " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Zahlungserinnerung: Rechnung " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Memento de plată: factură " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Recordatorio de pago: factura " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Betalingsherinnering: factuur " + this.se_facture_no;
      else return "Payment reminder: invoice " + this.se_facture_no;
    },
    getTitleSecondReminder(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Deuxième rappel de paiement : facture " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Zahlungserinnerung: Rechnung " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Memento de plată: factură " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Recordatorio de pago: factura " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Betalingsherinnering: factuur " + this.se_facture_no;
      else return "Second payment reminder: invoice " + this.se_facture_no;
    },
    getTitleThirdReminder(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Troisième et dernier rappel de paiement avant prise en compte des intérêts de retard : facture " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Dritte und letzte Zahlungserinnerung vor Zinsberechnung: Rechnung " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Al treilea și ultimul memento de plată înainte de calcularea penalităților: factură " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Tercer y último recordatorio de pago antes de aplicar intereses por retraso: factura " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Derde en laatste betalingsherinnering vóór de rente wordt berekend: factuur " + this.se_facture_no;
      else return "Third and final payment reminder before interest calculation: invoice " + this.se_facture_no;
    },
    getTitleMajorationReminder(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "4ème rappel de paiement – nouvelle facture majorée d'intérêts de retard";
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Vierte Zahlungserinnerung – Neue Rechnung mit Verzugszinsen";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "A patra notificare de plată – factură nouă majorată cu penalități de întârziere";
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Cuarto recordatorio de pago – Nueva factura con intereses por retraso";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Vierde betalingsherinnering – Nieuwe factuur met rente";
      else
        return "Fourth payment reminder – New invoice with late payment interest";
    },
    //OK
    getThirdContent(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return (
          "Sauf erreur ou omission de notre part, le paiement de la facture " +
          this.se_facture_no +
          " est arrivé à échéance le " +
          this.se_date +
          ", et ce dernier ne nous est pas encore parvenu. Selon nos conditions générales de vente, la signature du CMR atteste que la commande a été livrée conformément à la facturation.<br/>Nous vous rappelons qu'il s'agit de notre troisième relance concernant ce règlement.<br/><br/>" +
          "Nous vous prions de bien vouloir procéder à son règlement dans les meilleurs délais, et vous adressons, à toutes fins utiles, un duplicata de cette facture en pièce jointe.<br/><br/>" +
          "Merci de votre compréhension.<br/><br/>" +
          "Ceci est un rappel automatique envoyé par notre logiciel comptable. Si vous avez déjà effectué le paiement, nous vous prions d'ignorer ce message et nous nous excusons pour l'envoi de ce mail.<br/><br/>"
        );
      else if (language.substring(0, 2).toLowerCase() == "de")
        return (
          "Sofern es sich nicht um einen Irrtum oder ein Versäumnis unsererseits handelt, ist die Zahlung der Rechnung " +
          this.se_facture_no +
          " am " +
          this.se_date +
          " fällig geworden und wurde bislang nicht beglichen. Laut unseren Allgemeinen Geschäftsbedingungen (AGB) bestätigt die Unterschrift des CMR, dass die Bestellung gemäß der Rechnung geliefert wurde.<br/>Wir möchten Sie daran erinnern, dass dies unsere dritte Mahnung bezüglich dieser Zahlung ist.<br/><br/>" +
          "Wir bitten Sie, die Zahlung so schnell wie möglich vorzunehmen, und senden Ihnen hiermit ein Duplikat dieser Rechnung in der Anlage.<br/><br/>" +
          "Vielen Dank für Ihr Verständnis.<br/><br/>" +
          "Dies ist eine automatische Erinnerung, die von unserer Buchhaltungssoftware gesendet wurde. Sollten Sie die Zahlung bereits vorgenommen haben, bitten wir Sie, diese Nachricht zu ignorieren und entschuldigen uns für die Unannehmlichkeiten.<br/><br/>"
        );
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return (
          "Cu excepția unei erori sau omisiuni din partea noastră, plata facturii " +
          this.se_facture_no +
          " a ajuns la scadență la data de " +
          this.se_date +
          " și nu a fost încă efectuată. Conform termenilor și condițiilor noastre generale de vânzare, semnătura pe CMR confirmă că comanda a fost livrată conform facturii.<br/>Vă reamintim că acesta este al treilea avertisment privind această plată.<br/><br/>" +
          "Vă rugăm să efectuați plata cât mai curând posibil și vă trimitem, în acest sens, un duplicat al acestei facturi în atașament.<br/><br/>" +
          "Vă mulțumim pentru înțelegere.<br/><br/>" +
          "Aceasta este o notificare automată trimisă de software-ul nostru contabil. Dacă ați efectuat deja plata, vă rugăm să ignorați acest mesaj și ne cerem scuze pentru trimiterea acestui e-mail.<br/><br/>"
        );
      else if (language.substring(0, 2).toLowerCase() == "es")
        return (
          "Salvo error u omisión por nuestra parte, el pago de la factura " +
          this.se_facture_no +
          " venció el " +
          this.se_date +
          " y aún no hemos recibido el mismo. Según nuestras condiciones generales de venta, la firma del CMR confirma que el pedido ha sido entregado conforme a la factura.<br/>Le recordamos que este es nuestro tercer recordatorio sobre este pago.<br/><br/>" +
          "Le rogamos que proceda con el pago lo antes posible, y le enviamos una copia de la factura en el adjunto para su conveniencia.<br/><br/>" +
          "Gracias por su comprensión.<br/><br/>" +
          "Este es un recordatorio automático enviado por nuestro software contable. Si ya ha realizado el pago, le pedimos que ignore este mensaje y nos disculpamos por el envío de este correo electrónico.<br/><br/>"
        );
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return (
          "Tenzij het een fout of weglating onzerzijds betreft, is de betaling van factuur " +
          this.se_facture_no +
          " vervallen op " +
          this.se_date +
          ". Volgens onze algemene verkoopvoorwaarden bevestigt de ondertekening van de CMR dat de bestelling is geleverd volgens de factuur.<br/>Wij herinneren u eraan dat dit onze derde betalingsherinnering is.<br/><br/>" +
          "Wij verzoeken u vriendelijk om de betaling zo spoedig mogelijk te voldoen, en wij sturen u ter informatie een duplicaat van deze factuur in de bijlage.<br/><br/>" +
          "Dank u voor uw begrip.<br/><br/>" +
          "Dit is een automatische herinnering die door onze boekhoudsoftware is verzonden. Indien u de betaling al heeft verricht, verzoeken wij u dit bericht te negeren en bieden wij onze excuses aan voor het verzenden van deze e-mail.<br/><br/>"
        );
      else
        return (
          "Dear Sir/Madam,<br/><br/>" +
          "Unless it is an error or omission on our part, the payment for invoice " +
          this.se_facture_no +
          " was due on " +
          this.se_date +
          " and we have not yet received it. According to our General Terms and Conditions of Sale, the signature of the CMR confirms that the order has been delivered in accordance with the invoice.<br/>We remind you that this is our third reminder regarding this payment.<br/><br/>" +
          "We kindly ask you to proceed with the payment as soon as possible, and we are sending you a duplicate of the invoice in the attachment for your convenience.<br/><br/>" +
          "Thank you for your understanding.<br/><br/>" +
          "This is an automatic reminder sent by our accounting software. If you have already made the payment, please disregard this message and we apologize for sending this email.<br/><br/>"
        );
    },    //OK
    getMajorationContent(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return (
          "Sauf erreur de notre part, nous n'avons toujours pas reçu le paiement de la facture " +
          this.se_facture_no +
          ", arrivée à échéance le " +
          this.se_date +
          ".<br/>Conformément à nos conditions générales de vente, une majoration de " + (this.se_montant / 100 * 12).toFixed(2) + " € a été appliquée, comme prévu en cas de retard de paiement.<br/><br/>" +
          "Nous vous invitons à procéder au règlement de la facture dans les meilleurs délais. Vous trouverez ci-joint un <a href='https://xylo.codesinn.com/web/download-majoration/protected-8458451512544qsfjfskfr8224f_fqi2/" +
          this.se_invoice_id + "/" + this.se_idmajoration + "'>récapitulatif</a>.<br/><br/>" +
          "Nous restons bien entendu à votre disposition pour toute question ou précision."
        );
      else if (language.substring(0, 2).toLowerCase() == "de")
        return (
          "Sofern es sich nicht um einen Irrtum unsererseits handelt, haben wir die Zahlung der Rechnung " +
          this.se_facture_no +
          " mit Fälligkeitsdatum am " +
          this.se_date +
          " noch nicht erhalten.<br/>Gemäß unseren Allgemeinen Geschäftsbedingungen wurde ein Zuschlag von " + (this.se_montant / 100 * 12).toFixed(2) + " € angewendet, wie bei Zahlungsverzug vorgesehen.<br/><br/>" +
          "Wir bitten Sie, die Rechnung so bald wie möglich zu begleichen. Ein <a href='https://xylo.codesinn.com/web/download-majoration/protected-8458451512544qsfjfskfr8224f_fqi2/" +
          this.se_invoice_id + "/" + this.se_idmajoration +
          "'>Duplikat der aktualisierten Rechnung</a> ist beigefügt.<br/><br/>" +
          "Für weitere Fragen stehen wir Ihnen selbstverständlich gerne zur Verfügung."
        );
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return (
          "Cu excepția unei erori din partea noastră, nu am primit încă plata pentru factura " +
          this.se_facture_no +
          ", care a fost scadentă la " +
          this.se_date +
          ".<br/>Conform termenilor noștri, a fost aplicată o majorare de " + (this.se_montant / 100 * 12).toFixed(2) + " €, conform prevederilor în caz de întârziere la plată.<br/><br/>" +
          "Vă rugăm să achitați această factură cât mai curând posibil. Găsiți atașat un <a href='https://xylo.codesinn.com/web/download-majoration/protected-8458451512544qsfjfskfr8224f_fqi2/" +
          this.se_invoice_id + "/" + this.se_idmajoration +
          "'>duplicat al facturii actualizate</a>.<br/><br/>" +
          "Rămânem la dispoziția dumneavoastră pentru orice întrebări sau clarificări suplimentare."
        );
      else if (language.substring(0, 2).toLowerCase() == "es")
        return (
          "Salvo error por nuestra parte, aún no hemos recibido el pago de la factura " +
          this.se_facture_no +
          ", que venció el " +
          this.se_date +
          ".<br/>De acuerdo con nuestras condiciones generales de venta, se ha aplicado un recargo de " + (this.se_montant / 100 * 12).toFixed(2) + " €, según lo previsto en caso de retraso en el pago.<br/><br/>" +
          "Le rogamos que abone la factura a la mayor brevedad. Le enviamos un <a href='https://xylo.codesinn.com/web/download-majoration/protected-8458451512544qsfjfskfr8224f_fqi2/" +
          this.se_invoice_id + "/" + this.se_idmajoration +
          "'>duplicado de la factura actualizada</a>.<br/><br/>" +
          "Quedamos a su disposición para cualquier consulta o aclaración adicional."
        );
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return (
          "Tenzij het een fout onzerzijds betreft, hebben we de betaling van factuur " +
          this.se_facture_no +
          ", die op " +
          this.se_date +
          " verviel, nog niet ontvangen.<br/>Volgens onze algemene voorwaarden is een toeslag van " + (this.se_montant / 100 * 12).toFixed(2) + " € toegepast bij betalingsachterstand.<br/><br/>" +
          "Wij verzoeken u vriendelijk om deze factuur zo spoedig mogelijk te voldoen. Een <a href='https://xylo.codesinn.com/web/download-majoration/protected-8458451512544qsfjfskfr8224f_fqi2/" +
          this.se_invoice_id + "/" + this.se_idmajoration +
          "'>duplicaat van de bijgewerkte factuur</a> is bijgevoegd.<br/><br/>" +
          "Wij staan natuurlijk tot uw beschikking voor eventuele vragen of verduidelijkingen."
        );
      else
        return (
          "Unless it is an error on our part, we have not yet received the payment for invoice " +
          this.se_facture_no +
          ", which was due on " +
          this.se_date +
          ".<br/>In accordance with our general terms of sale, a surcharge of " + (this.se_montant / 100 * 12).toFixed(2) + " € has been applied in case of delayed payment.<br/><br/>" +
          "We kindly ask you to settle the invoice as soon as possible. A <a href='https://xylo.codesinn.com/web/download-majoration/protected-8458451512544qsfjfskfr8224f_fqi2/" +
          this.se_invoice_id + "/" + this.se_idmajoration +
          "'>copy of the updated invoice</a> is attached.<br/><br/>" +
          "Please feel free to contact us for any questions or further clarification."
        );
    },
    getContent(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return (
          "Sauf erreur ou omission de notre part, le paiement de la facture " +
          this.se_facture_no +
          " est arrivé à échéance le " +
          this.se_date +
          ", et ce dernier ne nous est pas encore parvenu.<br/><br/>Nous vous prions de bien vouloir procéder à son règlement dans les meilleurs délais, et vous adressons, à toutes fins utiles, un duplicata de cette facture en pièce jointe.<br/><br/>Merci de votre compréhension.<br/><br/>Ceci est un rappel automatique envoyé par notre logiciel comptable. Si vous avez déjà effectué le paiement nous nous excusons pour l'envoi de ce mail."
        );
      else if (language.substring(0, 2).toLowerCase() == "de")
        return (
          "Hallo,<br/><br/>" +
          "Die Zahlung der Rechnung " +
          this.se_facture_no +
          " war unseres Wissens am " +
          this.se_date +
          " fällig und ist noch nicht erfolgt.<br/><br/>" +
          "Könnten Sie die Rechnung bitte so schnell wie möglich bezahlen? Falls Sie es brauchen, finden Sie ein Duplikat der Rechnung in der Anlage.<br/><br/>" +
          "Danke für Ihr Verständnis.<br/><br/>" +
          "Dies ist eine automatische Erinnerung, die von unserer Buchhaltungssoftware gesendet wird. " +
          "Wenn Sie die Zahlung bereits getätigt haben, entschuldigen Sie bitte die Zusendung dieser E-Mail."
        );
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return (
          "Din câte știm, plata facturii " +
          this.se_facture_no +
          " era scadentă în data de " +
          this.se_date +
          ", și nu a fost încă efectuată.<br/><br/>Ați putea vă rog să o plătiți cât mai curând posibil? În cazul în care aveți nevoie, găsiți un duplicat al facturii în atașament.<br/><br/>Multumesc pentru intelegere.<br/><br/>Acesta este un memento automat trimis de software-ul nostru de contabilitate. Dacă ați efectuat deja plata, ne cerem scuze pentru trimiterea acestui e-mail."
        );
      else if (language.substring(0, 2).toLowerCase() == "es")
        return (
          "Por lo que sabemos, el pago de la factura " +
          this.se_facture_no +
          " vence el " +
          this.se_date +
          ", y aún no se ha realizado.<br/><br/>¿Podrías pagarlo lo antes posible? En caso de que lo necesite, encontrará un duplicado de la factura en el adjunto.<br/><br/>Gracias por su comprensión.<br/><br/>Este es un recordatorio automático enviado por nuestro software de contabilidad. Si ya ha realizado el pago, le pedimos disculpas por enviar este correo electrónico."
        );
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return (
          "Tenzij we ons vergissen, was de betaling van factuur " +
          this.se_facture_no +
          " verschuldigd op " +
          this.se_date +
          ", en is nog niet gedaan.<br/><br/>Kunt u deze zo snel mogelijk betalen? Voor het geval u het nodig heeft, vindt u een duplicaat van de factuur in de bijlage.<br/><br/>Bedankt voor uw begrip.<br/><br/>Dit is een automatische herinnering die door onze boekhoudsoftware wordt verzonden. Als u de betaling al heeft gedaan, bieden wij u onze excuses aan voor het verzenden van deze e-mail."
        );
      else
        return (
          "As far as we know, the payment of invoice " +
          this.se_facture_no +
          " was due on " +
          this.se_date +
          ", , and hasn't been done yet.<br/><br/>Could you please proceed to its payment as soon as possible? In case you need it, a duplicate of the invoice is attached.<br/><br/>Thank you for your understanding.<br/><br/>This is an automatic reminder sent by our accounting software. If you have already made the payment we apologize for sending this email."
        );
    },
    //OK
    getTopMsg(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Madame, Monsieur,";
      else if (language.substring(0, 2).toLowerCase() == "de") return "Hallo,";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Dragă,";
      else if (language.substring(0, 2).toLowerCase() == "es") return "Señora, Señor,";
      else if (language.substring(0, 2).toLowerCase() == "ne") return "Beste,";
      else return "Hi,";
    },
    //OK
    getBottomMsg(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Cordialement,<br/>L'équipe comptable<br/>Acacia Bois / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "mfG,<br/>Das Buchhaltungsteam<br/>Robinienpfähle / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Cu stima,<br/>Echipa de contabilitate<br/>Stalpi Salcam / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Atentamente,<br/>el equipo de contabilidad<br/>Estacas de Acacia / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Met vriendelijke groeten,<br/>Het boekhoudteam<br/>Robinia Palen / Xylo Impact";
      else return "Kind regards,<br/>The accounting team<br/>Acacia Poles / Xylo Impact";
    },
    getName(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "L'équipe comptable - Acacia Bois / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Das Buchhaltungsteam - Robinienpfähle / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Echipa de contabilitate - Stalpi Salcam / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "El equipo contable - Estacas de acacia / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Het boekhoudteam - Robinia Palen / Xylo Impact";
      else return "The accounting team - Acacia Poles / Xylo Impact";
    },
    async getSignatureQuote(language) {
      try {
        // Language configuration
        const langConfig = {
          fr: {
            logo: 'ab_fr.png',
            name: 'ACACIA BOIS',
            phone: 'Mobile BE:',
            phoneNumber: '+32 473 233 337',
            exhibitionTitle: 'Nous exposons:'
          },
          en: {
            logo: 'ab_en.png',
            name: 'ACACIA POLES',
            phone: 'Mobile BE:',
            phoneNumber: '+32 473 233 337',
            exhibitionTitle: 'Exhibiting:'
          },
          es: {
            logo: 'ab_es.png',
            name: 'ESTACAS DE ACACIA',
            phone: 'Móvil BE:',
            phoneNumber: '+32 473 233 337',
            exhibitionTitle: 'Exponemos:'
          },
          ro: {
            logo: 'ab_ro.png',
            name: 'STALPI SALCAM',
            phone: 'Mobil RO:',
            phoneNumber: '+40 770 000 000',
            exhibitionTitle: 'Expunem:'
          },
          de: {
            logo: 'ab_de.png',
            name: 'ROBINIENPFÄHLE',
            phone: 'Handy DE:',
            phoneNumber: '+49 176 982 479 66',
            exhibitionTitle: 'Wir stellen aus:'
          },
          ne: {
            logo: 'ab_nl.png',
            name: 'ROBINIA PALEN',
            phone: 'Mobiel BE:',
            phoneNumber: '+32 473 23 33 37',
            exhibitionTitle: 'Wij exposeren:'
          }
        };

        const lang = language.substring(0, 2).toLowerCase();
        // La langue arrive soit en code ('nl'), soit en nom ('Nederlands' -> 'ne')
        // selon l'ecran : sans cet alias, un client neerlandais retombait sur la
        // signature anglaise (logo ACACIA POLES) sous un corps de mail en NL.
        const config = langConfig[lang === 'nl' ? 'ne' : lang] || langConfig.en;

        // Fetch exhibition images
        let exhibitionHtml = '';
        try {
          const response = await axios.get('https://xylo.codesinn.com/signature/salon_selection.json');
          const selectedImages = response.data.selected_images || [];

          if (selectedImages.length > 0) {
            const timestamp = Date.now();
            const imageHtml = selectedImages.map(imageName => `
              <div style="margin-bottom: 10px; padding: 8px; background-color: #fff; border: 1px solid #ddd;">
                <div style="margin-bottom: 8px; text-align: center;">
                  <img src="https://xylo.codesinn.com/signature/upload/${imageName}?t=${timestamp}" alt="Salon Logo" style="display: block; max-width: 100%; height: auto;" />
                </div>
              </div>
            `).join('');

            exhibitionHtml = `
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        <tr>
            <td align="left" style="padding: 0;">
                <table width="420" cellpadding="0" cellspacing="0" border="0" style="width: 420px; border-collapse: collapse; font-family: Arial, sans-serif; color: #333; margin-top: 10px; border: 1px solid #e0e0e0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td style="padding: 8px; background-color: #f8f9fa; border-top: 2px solid #0073b1;">
                            <div style="font-size: 13px; font-weight: bold; color: #0073b1; margin-bottom: 8px; text-align: left;">
                                    ${config.exhibitionTitle}
                            </div>

                            ${imageHtml}

                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
    `;
          }
        } catch (error) {
          console.error('Error fetching exhibition images:', error);
        }

        // Generate main signature HTML
        return `<div style="text-align: left; width: 100%; margin: 0;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        <tr>
            <td align="left" style="padding: 0;">
                <table width="420" cellpadding="0" cellspacing="0" border="0" style="width: 420px; border-collapse: collapse; font-family: Arial, sans-serif; color: #333; line-height: 1.4; border-top: 2px solid #0073b1; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td style="vertical-align: middle; padding: 10px 15px 10px 10px; width: 120px;">
                            <img src="https://xylo.codesinn.com/image/${config.logo}" alt="${config.name} Logo" style="display: block;" />
                        </td>
                        <td style="vertical-align: top; padding: 10px 10px 10px 0;">


                            <div style="font-size: 13px; color: #333; font-weight: bold; margin-bottom: 8px;">${config.name}</div>


                            <div style="margin-bottom: 8px;">

                                <div><a href="https://www.acaciabois.com" target="_blank" style="text-decoration: none; color: #0073b1;">www.acaciabois.com</a></div>
                            </div>

                            <div style="margin-bottom: 0;">
                                <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                                    <tr>
                                        <td style="padding-right: 8px; vertical-align: middle;">
                                            <a href="https://www.instagram.com/acaciabois/" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/instagram.png" alt="Instagram" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                        <td style="padding-right: 8px; vertical-align: middle;">
                                            <a href="https://www.facebook.com/acacia.bois.piquets/" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/facebook.png" alt="Facebook" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                        <td style="padding-right: 8px; vertical-align: middle;">
                                            <a href="https://www.linkedin.com/company/acacia-bois" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/linkedin.png" alt="LinkedIn" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                        <td style="vertical-align: middle;">
                                            <a href="https://g.page/r/CQ5mo8xGMDriEBM/review" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/google.png" alt="Google" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" style="padding: 10px; border-top: 1px solid #ccc;">
                            <div style="font-size: 9px; color: #777; text-align: left; line-height: 1.2;">
                                FSC &reg; CERTIFIED (SGSCH-COC-011793) | ISO9001-2015 CERTIFIED
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>

${exhibitionHtml}
    </div>`;
      } catch (error) {
        console.error('Error generating signature:', error);
        return '';
      }
    },
    getFromEmail(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "sales@acaciabois.com"
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "sales@acaciabois.com"
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "sales@acaciabois.com"
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "sales@acaciabois.com"
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "sales@acaciabois.com"
      else return "sales@acaciabois.com"
    },
    extractNumber(str) {
      if (!str) return null;
      const regex = /\d+/;
      const result = String(str).match(regex);
      return result ? parseInt(result[0], 10) : null;
    },
    async sendEmailReminder() {
      this.$vs.loading();
      if (!(await this.guardBeforeSend())) {
        this.$vs.loading.close();
        return;
      }
      this.buttonisshow = false;

      let dataz = null;
      try {
        // Le numéro de relance est validé par guardBeforeSend : 1, 2 ou 3.
        const step = this.extractNumber(this.se_whichone);
        let title = null;
        if (step === 1) title = this.getTitleFirstReminder(this.se_language);
        else if (step === 2) title = this.getTitleSecondReminder(this.se_language);
        else title = this.getTitleThirdReminder(this.se_language);
        this.se_title = title

        let hello = this.getTopMsg(this.se_language);
        let message = null
        if (step === 3) message = this.getThirdContent(this.se_language);
        else message = this.getContent(this.se_language);
        let goodbye = this.getBottomMsg(this.se_language);
        let fromemail = this.getFromEmail(this.se_language);

        let reply_mail = 'ferdinand.terlinden@acaciabois.com;';
        if (this.se_brokermail) reply_mail = this.se_brokermail+",mariana.nagy@xyloimpact.com"

        // Get signature based on language
        const signature = await this.getSignatureQuote(this.se_language);

        let pdfUrl = this.se_invoice_pdf_url;
        let pdfFilename = this.se_invoice_pdf_filename || `invoice_${this.se_invoice_id}`;
        let pdfBase64 = null;
        try {
          pdfBase64 = await this.fetchInvoicePdfBase64(pdfUrl);
        } catch (error) {
          this.buttonisshow = true;
          this.$vs.loading.close();
          this.reportSendFailure(
            'The invoice PDF could not be downloaded from the server, so the e-mail was not sent — a reminder never goes out without its invoice copy. Regenerate the PDF from the invoice screen and try again',
            error
          );
          return;
        }

        dataz = {
          template_id: "template_cfvx026",
          operation_ids: [this.se_invoice_id], // broker de la facture en Cc (serveur)
          template_params: {
            se_title: title,
            se_hello: hello,
            se_from_email: fromemail,
            se_message: message,
            se_reply_mail: reply_mail,
            se_cc: 'ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com;' + (this.se_brokermail ? this.se_brokermail : ''),
            se_goodbye: goodbye,
            se_mail: this.datamail,
            se_from_name: this.getName(this.se_language),
            se_signature: signature,
            // SMTP Dynamic Attachment
            attachment_content: pdfUrl || pdfBase64,
            filename: pdfFilename,
            pdf_url: pdfUrl || '',
          },
        };
      } catch (error) {
        this.buttonisshow = true;
        this.$vs.loading.close();
        this.reportSendFailure(
          'The reminder could not be prepared (subject, body or signature), so nothing was sent',
          error
        );
        return;
      }

      try {
        const response = await axios.post("/mail/send", dataz);
        this.insertInDb(response.statusText + "/" + response.status);
        this.$vs.notify({
          color: "success",
          title: "Email sent correctly!",
          text: "Response from the mail server : " + response.statusText + "/" + response.status,
        });
        this.direct_answer_from_the_server = response.statusText + "/" + response.status;
      } catch (error) {
        this.buttonisshow = true;
        this.reportSendFailure(
          'The mail server refused the reminder (SMTP). Nothing was delivered to the client',
          error
        );
      } finally {
        this.$vs.loading.close();
      }
    },
    /*
          else if (this.se_whichone === 'Send advance to client') {
            let title = null
            this.se_content = this.se_content + " " + this.getContentAdvance(this.se_language);
            this.se_content = this.se_content + " " + this.getBottomMsgAdvance(this.se_language);
            this.se_title = title
          }
          else if (this.se_whichone === 'Send credit note to client') {
            let title = null
            this.se_content = this.se_content + " " + this.getContentInvoiceCredit(this.se_language);
            this.se_content = this.se_content + " " + this.getBottomMsgCredit(this.se_language);
            this.se_title = title
          }

    */
    getTitleCredit(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Note de crédit " + this.se_facture_no + " - Acacia Bois / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Gutschrift " + this.se_facture_no + " - Robinienpfähle / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Notă de credit " + this.se_facture_no + " - Stalpi Salcam / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Nota de crédito " + this.se_facture_no + " - Estacas de Acacia / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Creditnota " + this.se_facture_no + " - Robinia Palen / Xylo Impact";
      else
        return "Credit Note " + this.se_facture_no + " - Acacia Poles / Xylo Impact";
    },

    getContentCredit(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return (
          "Veuillez trouver ci-dessous votre note de crédit " +
          this.se_facture_no + " en pièce jointe.<br/><br/>Merci pour votre confiance."
        );
      else if (language.substring(0, 2).toLowerCase() == "de")
        return (
          "Hier ist Ihre Gutschrift " +
          this.se_facture_no + " in der Anlage.<br/><br/>Vielen Dank für Ihr Vertrauen."
        );
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return (
          "Vă rugăm să găsiți mai jos nota dvs. de credit " +
          this.se_facture_no + " în atașament.<br/><br/>Vă mulțumim pentru încredere."
        );
      else if (language.substring(0, 2).toLowerCase() == "es")
        return (
          "Adjuntamos su nota de crédito " +
          this.se_facture_no + " en el adjunto.<br/><br/>Gracias por su confianza."
        );
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return (
          "Hierbij uw creditnota " +
          this.se_facture_no + " in de bijlage.<br/><br/>Bedankt voor uw vertrouwen."
        );
      else
        return (
          "Please find your credit note " +
          this.se_facture_no + " in the attachment.<br/><br/>Thank you for your trust."
        );
    },

    getTitleAdvance(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Facture d'avance " + this.se_facture_no + " - Acacia Bois / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Anzahlungsrechnung " + this.se_facture_no + " - Robinienpfähle / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Factură de avans " + this.se_facture_no + " - Stalpi Salcam / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Factura de anticipo " + this.se_facture_no + " - Estacas de Acacia / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Vooruitbetalingsfactuur " + this.se_facture_no + " - Robinia Palen / Xylo Impact";
      else
        return "Advance Invoice " + this.se_facture_no + " - Acacia Poles / Xylo Impact";
    },

    getContentAdvance(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return (
          "Veuillez trouver ci-dessous votre facture d'avance " +
          this.se_facture_no + " en pièce jointe.<br/><br/>Merci pour votre confiance."
        );
      else if (language.substring(0, 2).toLowerCase() == "de")
        return (
          "Hier ist Ihre Anzahlungsrechnung " +
          this.se_facture_no + " in der Anlage.<br/><br/>Vielen Dank für Ihr Vertrauen."
        );
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return (
          "Vă rugăm să găsiți mai jos factura dvs. de avans " +
          this.se_facture_no + " în atașament.<br/><br/>Vă mulțumim pentru încredere."
        );
      else if (language.substring(0, 2).toLowerCase() == "es")
        return (
          "Adjuntamos su factura de anticipo " +
          this.se_facture_no + " en el adjunto.<br/><br/>Gracias por su confianza."
        );
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return (
          "Hierbij uw vooruitbetalingsfactuur " +
          this.se_facture_no + " in de bijlage.<br/><br/>Bedankt voor uw vertrouwen."
        );
      else
        return (
          "Please find your advance invoice " +
          this.se_facture_no + " in the attachment.<br/><br/>Thank you for your trust."
        );
    },

    getTitleInvoice(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Expédition de votre commande " + this.se_facture_no;
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Rechnung " + this.se_facture_no + " - Robinienpfähle / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Factură " + this.se_facture_no + " - Stalpi Salcam / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Factura " + this.se_facture_no + " - Estacas de Acacia / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Factuur " + this.se_facture_no + " - Robinia Palen / Xylo Impact";
      else return "Invoice " + this.se_facture_no + " - Acacia Poles / Xylo Impact";
    },

    // Une ligne d'adresse n'est exploitable que si elle porte au moins la rue
    // ou la ville : le reste ne suffit pas a livrer.
    isUsableAddress(addressData) {
      if (!addressData) return false;
      return Boolean(addressData.street || addressData.place_name || addressData.postal_code);
    },

    hasDeliveryAddress() {
      return this.isUsableAddress(this.se_delivery_address);
    },

    // D'ou sort l'adresse affichee dans le popup : la question que se posait
    // Ferdinand quand elle semblait "effacee".
    deliveryAddressSourceLabel() {
      switch (this.se_delivery_address_source) {
        case 'operation_delivery': return "delivery address of the invoice";
        case 'operation_billing': return "billing address of the invoice (no delivery address on it)";
        case 'quotation_delivery': return "delivery address of the original quotation";
        case 'quotation_billing': return "billing address of the original quotation";
        case 'client_default': return "default address of the client";
        default: return "unknown source";
      }
    },

    // Le tableau Overdue ne ramene l'adresse que via operations.idaddressdelivery.
    // Quand ce lien manque, on interroge l'API qui remonte la cascade
    // (facture -> devis d'origine -> client) avant de renoncer.
    async resolveDeliveryAddressForInvoice(idoperation) {
      if (!idoperation) return;
      try {
        const response = await axios.get("/operation/resolvedeliveryaddress/" + idoperation);
        const resolved = response.data;
        if (resolved && this.isUsableAddress(resolved)) {
          this.se_delivery_address = {
            street: resolved.street || '',
            number: resolved.number || '',
            postal_code: resolved.postal_code || '',
            place_name: resolved.place_name || '',
            region: resolved.region || '',
            name_en: resolved.name_en || ''
          };
          this.se_delivery_address_source = resolved.source;
        } else {
          this.se_delivery_address = null;
          this.se_delivery_address_source = 'none';
        }
      } catch (error) {
        this.se_delivery_address = null;
        this.se_delivery_address_source = 'none';
      }
    },

    formatDeliveryAddress(language, addressData) {
      // Ne JAMAIS renvoyer de placeholder ici : ce texte part tel quel dans le
      // mail au client. Une adresse absente donne une chaine vide, et les
      // gabarits de getContentInvoice omettent alors la phrase d'adresse.
      if (!addressData) return "";

      // Build address parts
      let addressParts = [];

      // Street and number
      if (addressData.street) {
        let streetLine = addressData.street;
        if (addressData.number) {
          streetLine += ' ' + addressData.number;
        }
        addressParts.push(streetLine);
      }

      // Postal code and city
      if (addressData.postal_code && addressData.place_name) {
        addressParts.push(addressData.postal_code + ' ' + addressData.place_name);
      } else if (addressData.postal_code) {
        addressParts.push(addressData.postal_code);
      } else if (addressData.place_name) {
        addressParts.push(addressData.place_name);
      }

      // Region (optional)
      if (addressData.region) {
        addressParts.push(addressData.region);
      }

      // Country
      if (addressData.name_en) {
        addressParts.push(addressData.name_en);
      }

      return addressParts.join(', ');
    },

    getContentInvoice(language, hasRemainingBalance = false, childQuotationId = null, remainingProducts = []) {
      const getRemainingProductDescription = (item) => {
        if (!item) return ''
        const lang = language.substring(0, 2).toLowerCase()
        const keys = [
          'devis_description_translated_client',
          'devis_description_translated',
          `devis_description_${lang}`,
          `product_description_${lang}`,
          `product_name_${lang}`,
          `description_${lang}`,
          `name_${lang}`,
        ]
        const pick = (obj) => {
          for (const key of keys) {
            const value = obj && obj[key]
            if (value && String(value).trim()) return value
          }
          return null
        }
        return (
          pick(item) ||
          pick(item.product) ||
          pick(item.operations_products) ||
          item.devis_description ||
          item.description ||
          item.name ||
          ''
        )
      }

      // Adresse formatee une seule fois : vide, on omet la mention plutot que
      // d'envoyer au client une phrase tronquee ("à l'adresse suivante: ").
      const deliveryAddress = this.formatDeliveryAddress(language, this.se_delivery_address);
      const addressBlock = (label) => {
        if (!deliveryAddress) return "";
        return "<b>" + label + ": " + deliveryAddress + "</b><br/><br/>";
      };

      let baseMessage = "";
      if (language.substring(0, 2).toLowerCase() == "fr") {
        baseMessage = deliveryAddress
          ? "Votre commande a été expédiée et sera livrée dans les prochains jours ouvrables à l'adresse suivante: " + deliveryAddress + "<br/><br/>"
          : "Votre commande a été expédiée et sera livrée dans les prochains jours ouvrables.<br/><br/>";

        // Add partial delivery section if applicable
        if (hasRemainingBalance && remainingProducts && remainingProducts.length > 0) {
          const missingProducts = remainingProducts.filter(item => parseFloat(item.delta_quantity) < 0);
          if (missingProducts.length > 0) {
            baseMessage += "<b>! Livraison partielle</b><br/>En raison d'un manque de place dans le camion, certains produits seront livrés ultérieurement :<br/>";
            missingProducts.forEach(item => {
              const quantity = Math.abs(parseFloat(item.delta_quantity));
              const description = getRemainingProductDescription(item);
              baseMessage += "• " + description + " : " + quantity + " unités en attente<br/>";
            });
            baseMessage += "<br/>";
          }
        }

        baseMessage += "<b>Informations importantes:</b><br/>";
        baseMessage += "• Merci de vérifier l'accès pour un camion semi-remorque de 40 tonnes<br/>";
        baseMessage += "• Toute marchandise manquante ou endommagée doit être mentionnée sur le CMR. Si tel est le cas, merci de nous appeler immédiatement afin que nous tentions de résoudre le problème — il arrive, notamment lors d'un groupage, qu'un client précédent ait déchargé par erreur une palette supplémentaire.<br/>";
        baseMessage += "• Pour connaître la date ou le créneau de livraison: contactez Mariana en répondant à cet e-mail<br/><br/>";
        baseMessage += "<b>Facturation:</b><br/>";
        baseMessage += "Vous trouverez votre facture " + this.se_facture_no + " en pièce jointe.<br/>";
        baseMessage += "Nous n'acceptons que les paiements par virement bancaire.<br/><br/>";
      }
      else if (language.substring(0, 2).toLowerCase() == "de")
        baseMessage =
          "Wir haben Ihre Bestellung auf einen LKW verladen. Er wird in den nächsten Werktagen zur Lieferadresse gehen.<br/><br/>" + addressBlock("Lieferadresse") + "Bitte überprüfen Sie den Zugang für einen 40t Sattelzug.<br/><br/>Jede fehlende oder beschädigte Ware muss im CMR vermerkt werden. Falls dies der Fall ist, rufen Sie uns bitte sofort an, damit wir versuchen können, das Problem zu lösen - es kommt vor, insbesondere bei Sammelladungen, dass ein vorheriger Kunde versehentlich eine zusätzliche Palette entladen hat.<br/><br/>Sie möchten weitere Informationen zum Liefertermin oder Zeitfenster? Bitte kontaktieren Sie Mariana, indem Sie auf diese E-Mail antworten.<br/><br/><b>Rechnung:</b><br/>Sie finden Ihre Rechnung " +
          this.se_facture_no + " im Anhang.<br/><br/><br/>Zögern Sie nicht, uns einen Kommentar und Sterne auf Google zu hinterlassen: <a href=\"https://g.page/r/CQ5mo8xGMDriEBM/review\">https://g.page/r/CQ5mo8xGMDriEBM/review</a><br/>";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        baseMessage =
          "Am încărcat comanda dumneavoastră într-un camion. Va merge la adresa de livrare in urmatoarele zile lucratoare.<br/><br/>" + addressBlock("Adresa de livrare") + "Vă rugăm să verificați accesul pentru o camion semi-remorcă de 40t.<br/><br/>Orice marfă lipsă sau deteriorată trebuie menționată pe CMR. Dacă este cazul, vă rugăm să ne sunați imediat pentru a încerca să rezolvăm problema - se întâmplă, în special la grupaj, ca un client anterior să fi descărcat din greșeală o paletă suplimentară.<br/><br/>Doriți mai multe informații despre data livrării sau intervalul orar? Vă rugăm să o contactați pe Mariana răspunzând la acest e-mail.<br/><br/><b>Facturare:</b><br/>Veți găsi factura " +
          this.se_facture_no + " în atașament.<br/><br/><br/>Nu ezitați să ne lăsați un comentariu și stele pe Google: <a href=\"https://g.page/r/CQ5mo8xGMDriEBM/review\">https://g.page/r/CQ5mo8xGMDriEBM/review</a><br/><br/><br/><br/>Multumesc pentru intelegere.";
      else if (language.substring(0, 2).toLowerCase() == "es")
        baseMessage =
          "Hemos cargado su pedido en un camión. Acudirá a la dirección de entrega en los próximos días laborables.<br/><br/>" + addressBlock("Dirección de entrega") + "Por favor, verifique el acceso para un camión de semi-remolque de 40t.<br/><br/>Toda mercancía faltante o dañada debe ser mencionada en el CMR. Si este es el caso, por favor llámenos inmediatamente para que intentemos resolver el problema - sucede, especialmente en un agrupamiento, que un cliente anterior haya descargado por error una paleta adicional.<br/><br/>¿Quieres más información sobre la fecha o franja horaria de entrega? Póngase en contacto con Mariana respondiendo a este correo electrónico.<br/><br/><b>Facturación:</b><br/>Encontrará su factura " +
          this.se_facture_no + " en el archivo adjunto.<br/><br/><br/>No dudes en dejarnos un comentario y estrellas en Google: <a href=\"https://g.page/r/CQ5mo8xGMDriEBM/review\">https://g.page/r/CQ5mo8xGMDriEBM/review</a><br/><br/><br/><br/>Gracias por su comprensión.";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        baseMessage =
          "We hebben uw bestelling op een vrachtwagen geladen. U mag de lading de komende werkdagen op het afleveradres verwachten.<br/><br/>" + addressBlock("Afleveradres") + "Gelieve de toegang te controleren voor een vrachtwagen met oplegger van 40t.<br/><br/>Alle ontbrekende of beschadigde goederen moeten op het CMR worden vermeld. Als dit het geval is, bel ons dan onmiddellijk op zodat we het probleem kunnen proberen op te lossen - het gebeurt, vooral bij groepage, dat een eerdere klant per ongeluk een extra pallet heeft gelost.<br/><br/>Wenst u meer informatie over de leveringsdatum of het tijdslot? Gelieve dan contact op te nemen met Mariana door deze e-mail te beantwoorden.<br/><br/><b>Facturatie:</b><br/>U vindt uw factuur " +
          this.se_facture_no + " in de bijlage.<br/><br/><br/>Voel je vrij om een reactie en sterren op Google achter te laten: <a href=\"https://g.page/r/CQ5mo8xGMDriEBM/review\">https://g.page/r/CQ5mo8xGMDriEBM/review</a><br/><br/><br/><br/>Bedankt voor uw begrip.";
      else
        baseMessage =
          "We have loaded your order on a lorry. He will go to the delivery address in the next working days.<br/><br/>" + addressBlock("Delivery address") + "Please verify access for a 40t semi-trailer truck.<br/><br/>Any missing or damaged goods must be mentioned on the CMR. If this is the case, please call us immediately so that we can try to resolve the problem - it happens, especially during groupage, that a previous client has mistakenly unloaded an additional pallet.<br/><br/>Would you like more information about the delivery date or time slot? Please contact Mariana by replying to this email.<br/><br/><b>Billing:</b><br/>You will find your invoice " +
          this.se_facture_no + " in the attachment.<br/><br/><br/>Feel free to leave us a comment and stars on Google: <a href=\"https://g.page/r/CQ5mo8xGMDriEBM/review\">https://g.page/r/CQ5mo8xGMDriEBM/review</a><br/><br/><br/><br/>Thank you for your understanding.";

      let remainingBalanceParagraph = "";
      if (hasRemainingBalance && remainingProducts && remainingProducts.length > 0) {
        const missingProducts = remainingProducts.filter(item => parseFloat(item.delta_quantity) < 0);
        const addedProducts = remainingProducts.filter(item => parseFloat(item.delta_quantity) > 0);

        let productsList = "";
        missingProducts.forEach(item => {
          const quantity = Math.abs(parseFloat(item.delta_quantity));
          const description = getRemainingProductDescription(item);
          if (language.substring(0, 2).toLowerCase() == "fr") productsList += `<br/>- ${description} : ${quantity} manquants`;
          else if (language.substring(0, 2).toLowerCase() == "de") productsList += `<br/>- ${description} : ${quantity} fehlend`;
          else if (language.substring(0, 2).toLowerCase() == "ro") productsList += `<br/>- ${description} : ${quantity} lipsă`;
          else if (language.substring(0, 2).toLowerCase() == "es") productsList += `<br/>- ${description} : ${quantity} faltantes`;
          else if (language.substring(0, 2).toLowerCase() == "ne") productsList += `<br/>- ${description} : ${quantity} ontbrekend`;
          else productsList += `<br/>- ${description} : ${quantity} missing`;
        });

        addedProducts.forEach(item => {
          const quantity = parseFloat(item.delta_quantity);
          const description = getRemainingProductDescription(item);
          if (language.substring(0, 2).toLowerCase() == "fr") productsList += `<br/>- ${description} : ${quantity} en plus`;
          else if (language.substring(0, 2).toLowerCase() == "de") productsList += `<br/>- ${description} : ${quantity} zusätzlich`;
          else if (language.substring(0, 2).toLowerCase() == "ro") productsList += `<br/>- ${description} : ${quantity} în plus`;
          else if (language.substring(0, 2).toLowerCase() == "es") productsList += `<br/>- ${description} : ${quantity} adicionales`;
          else if (language.substring(0, 2).toLowerCase() == "ne") productsList += `<br/>- ${description} : ${quantity} extra`;
          else productsList += `<br/>- ${description} : ${quantity} added`;
        });

        if (language.substring(0, 2).toLowerCase() == "fr")
          remainingBalanceParagraph = `<br/><br/><b>Informations concernant le solde de livraison:</b>${productsList}<br/><br/>Si vous désirez modifier ce solde ou annuler la livraison de celui-ci, merci de nous en informer.`;
        else if (language.substring(0, 2).toLowerCase() == "de")
          remainingBalanceParagraph = `<br/><br/><b>Informationen zum Liefersaldo:</b>${productsList}<br/><br/>Wenn Sie diesen Saldo ändern oder dessen Lieferung stornieren möchten, informieren Sie uns bitte.`;
        else if (language.substring(0, 2).toLowerCase() == "ro")
          remainingBalanceParagraph = `<br/><br/><b>Informații privind soldul livrării:</b>${productsList}<br/><br/>Dacă doriți să modificați acest sold sau să anulați livrarea acestuia, vă rugăm să ne anunțați.`;
        else if (language.substring(0, 2).toLowerCase() == "es")
          remainingBalanceParagraph = `<br/><br/><b>Información sobre el saldo de entrega:</b>${productsList}<br/><br/>Si desea modificar este saldo o cancelar su entrega, por favor infórmenos.`;
        else if (language.substring(0, 2).toLowerCase() == "ne")
          remainingBalanceParagraph = `<br/><br/><b>Informatie over het leveringssaldo:</b>${productsList}<br/><br/>Als u dit saldo wilt wijzigen of de levering ervan wilt annuleren, laat het ons dan weten.`;
        else
          remainingBalanceParagraph = `<br/><br/><b>Information about the delivery balance:</b>${productsList}<br/><br/>If you wish to modify this balance or cancel its delivery, please let us know.`;
      }

      return baseMessage + remainingBalanceParagraph;
    },
    getTranslatedProductNameForDifference (item, products, language) {
      if (!item || !products || !products.length) return ''
      const lang = (language || 'en').substring(0, 2).toLowerCase()
      const idFromItem = this.getDifferenceProductId(item)

      let product = null
      if (idFromItem) {
        product = products.find(p => {
          const productId = (p.operations_products && p.operations_products.idproduct) || p.id
          return String(productId) === String(idFromItem)
        })
      }

      const normalizeText = (value) =>
        String(value || '')
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '')

      if (!product && item.devis_description) {
        const needleRaw = String(item.devis_description).trim().toLowerCase()
        const needle = normalizeText(needleRaw)
        product = products.find(p => {
          const desc = (p.operations_products && p.operations_products.description) || ''
          const nameEn = p.name_en || ''
          const descNorm = normalizeText(desc)
          const nameNorm = normalizeText(nameEn)
          return (
            descNorm === needle ||
            nameNorm === needle ||
            descNorm.includes(needle) ||
            needle.includes(descNorm) ||
            nameNorm.includes(needle) ||
            needle.includes(nameNorm)
          )
        })
      }

      if (!product) return ''

      const nameMap = {
        fr: product.name_fr,
        en: product.name_en,
        ro: product.name_ro,
        de: product.name_de,
        es: product.name_es,
        nl: product.name_nl
      }

      const descMap = {
        fr: product.description_fr,
        en: product.description_en,
        ro: product.description_ro,
        de: product.description_de,
        es: product.description_es,
        nl: product.description_nl
      }

      return (
        (product.operations_products && product.operations_products.description_translated_client) ||
        (product.operations_products && product.operations_products.description_translated) ||
        nameMap[lang] ||
        descMap[lang] ||
        product.name_en ||
        product.description_en ||
        (product.operations_products && product.operations_products.description) ||
        product.description ||
        ''
      )
    },
    getDifferenceProductId (item) {
      return (
        item.idproduct ||
        item.product_id ||
        item.id_product ||
        item.idproductref ||
        item.id_product_ref ||
        item.idproductquotation ||
        item.idproduct_invoice ||
        null
      )
    },
    async resolveLanguageId (language) {
      if (this.se_language_id) return this.se_language_id
      const langCode = (language || '').substring(0, 2).toLowerCase()
      if (!langCode) return null
      try {
        const response = await axios.get('/languageslist')
        const list = response.data || []
        const match = list.find(item => {
          const code =
            (item.code || item.initials || item.iso || item.label || item.name_en || '').toString().toLowerCase()
          return code.startsWith(langCode)
        })
        return match ? (match.id || match.value || match.idlanguage) : null
      } catch (error) {
        console.error('resolveLanguageId failed (broker):', error)
        return null
      }
    },
    buildProductTranslationIndex (products, englishProducts = []) {
      const normalizeText = (value) =>
        String(value || '')
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '')

      const byId = new Map()
      const byKey = new Map()
      const byEnKey = new Map()

      const getProductId = (product) =>
        product.idproduct ||
        product.product_id ||
        product.id_product ||
        (product.operations_products && product.operations_products.idproduct) ||
        product.id ||
        null

      const getProductLabel = (product) =>
        product.description_translated_client ||
        product.description_translated ||
        product.description ||
        product.name ||
        (product.operations_products && product.operations_products.description_translated_client) ||
        (product.operations_products && product.operations_products.description_translated) ||
        (product.operations_products && product.operations_products.description) ||
        ''

      products.forEach(product => {
        const productId = getProductId(product)
        const translated = getProductLabel(product)

        if (productId && translated) {
          byId.set(String(productId), translated)
        }

        const candidateKeys = [
          product.description_en,
          product.name_en,
          product.devis_description,
          product.description,
          product.name,
          product.description_fr,
          product.description_de,
          product.description_ro,
          product.description_es,
          product.description_nl,
          (product.operations_products && product.operations_products.description),
        ]

        candidateKeys.forEach(key => {
          const normalized = normalizeText(key)
          if (normalized && translated) {
            byKey.set(normalized, translated)
          }
        })
      })

      if (englishProducts && englishProducts.length && englishProducts.length === products.length) {
        englishProducts.forEach((englishProduct, index) => {
          const translated = getProductLabel(products[index])
          const englishLabel =
            englishProduct.description ||
            englishProduct.description_en ||
            englishProduct.name_en ||
            (englishProduct.operations_products && englishProduct.operations_products.description) ||
            englishProduct.name ||
            ''
          const normalized = normalizeText(englishLabel)
          if (normalized && translated) {
            byEnKey.set(normalized, translated)
          }
        })
      }

      return { byId, byKey, byEnKey }
    },
    getTranslatedDescriptionFromIndex (item, index) {
      if (!item || !index) return ''
      const id = this.getDifferenceProductId(item)
      if (id && index.byId.has(String(id))) return index.byId.get(String(id))

      const normalizeText = (value) =>
        String(value || '')
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '')

      const keys = [
        item.devis_description,
        item.description,
        item.name
      ]

      for (const key of keys) {
        const normalized = normalizeText(key)
        if (normalized && index.byKey.has(normalized)) return index.byKey.get(normalized)
        if (normalized && index.byEnKey && index.byEnKey.has(normalized)) return index.byEnKey.get(normalized)
      }

      return ''
    },

    insertInDbInvoice() {
      let obj = {
        idinvoice: this.se_invoice_id
      };
      axios
        .post("/paymentreminder/newinvoicesent", obj)
        .then((response) => {
          //this.popupActive = false;
          this.$store.dispatch("dataListDashboard/fetchTotalValueOfUnpaidInvoice");
          this.$store.dispatch("dataListDashboard/fetchListOfUnpaidInvoice");
          this.datamail = null
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Error response data:', error.response.data);
            console.error('Error response status:', error.response.status);
            console.error('Error response headers:', error.response.headers);
            alert(`Error ${error.response.status}: ${error.response.data.message}`);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser
            console.error('Error request:', error.request);
            alert('Error: No response received from the server.');
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error message:', error.message);
            alert(`Error: ${error.message}`);
          }
        });
    },
    insertInDbMajoration() {
      let obj = {
        idinvoice: this.se_invoice_id
      };
      axios
        .post("/paymentreminder/newmajorationsent", obj)
        .then((response) => {
          //this.popupActive = false;
          this.$store.dispatch("dataListDashboard/fetchTotalValueOfUnpaidInvoice");
          this.$store.dispatch("dataListDashboard/fetchListOfUnpaidInvoice");
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Error response data:', error.response.data);
            console.error('Error response status:', error.response.status);
            console.error('Error response headers:', error.response.headers);
            alert(`Error ${error.response.status}: ${error.response.data.message}`);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser
            console.error('Error request:', error.request);
            alert('Error: No response received from the server.');
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error message:', error.message);
            alert(`Error: ${error.message}`);
          }
        });
    },
    async sendEmailMajoration() {
      this.$vs.loading();
      if (!(await this.guardBeforeSend())) {
        this.$vs.loading.close();
        return;
      }
      this.buttonisshow = false;
      let title = this.getTitleMajorationReminder(this.se_language);

      let reply_mail = 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com;mariana.nagy@xyloimpact.com';
      if (this.se_brokermail) reply_mail = this.se_brokermail+",mariana.nagy@xyloimpact.com"

      let hello = this.getTopMsg(this.se_language);
      let message = this.getMajorationContent(this.se_language);
      let goodbye = this.getBottomMsg(this.se_language);
      let fromemail = this.getFromEmail(this.se_language);

      // Pièce jointe : le PDF archivé. Sa présence et ses montants ont déjà été
      // contrôlés par guardBeforeSend ; il ne reste que l'échec de téléchargement,
      // qui est expliqué à l'écran au lieu d'échouer en silence.
      let pdfUrl = this.se_invoice_pdf_url;
      let pdfFilename = this.se_invoice_pdf_filename || `invoice_${this.se_invoice_id}`;
      let pdfBase64 = null;
      try {
        pdfBase64 = await this.fetchInvoicePdfBase64(pdfUrl);
      } catch (error) {
        this.buttonisshow = true;
        this.$vs.loading.close();
        this.reportSendFailure(
          'The invoice PDF could not be downloaded from the server, so the e-mail was not sent. Regenerate the PDF from the invoice screen and try again',
          error
        );
        return;
      }

      var dataz = {
        template_id: "template_cfvx026",
        operation_ids: [this.se_invoice_id], // broker de la facture en Cc (serveur)
        template_params: {
          se_title: title,
          se_hello: hello,
          se_from_email: fromemail,
          se_message: message,
          se_goodbye: goodbye,
          se_reply_mail: reply_mail,
          se_cc: 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com' + (this.se_brokermail ? ',' + this.se_brokermail : ''),
          se_mail: this.se_user_email,
          se_from_name: this.getName(this.se_language),
          // SMTP Dynamic Attachment
          attachment_content: pdfUrl || pdfBase64,
          filename: pdfFilename,
          pdf_url: pdfUrl || '',
        },

      };
      axios
        .post("/mail/send", dataz)
        .then((response) => {
          this.insertInDbMajoration();
          this.$vs.notify({
            color: "success",
            title: "Email sent correctly!",
            text:
              "Response from the mail server : " +
              response.statusText +
              "/" +
              response.status,
          });
          this.direct_answer_from_the_server =
            response.statusText + "/" + response.status;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.buttonisshow = true;
          this.reportSendFailure(
            'The mail server refused this e-mail (SMTP). Nothing was delivered to the client',
            error
          );
          this.$vs.loading.close();
        });
    },
    async sendEmailInvoiceCredit() {
      this.$vs.loading();
      if (!(await this.guardBeforeSend())) {
        this.$vs.loading.close();
        return;
      }
      this.buttonisshow = false;
      let title = this.getTitleCredit(this.se_language);

      let reply_mail = 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com';
      if (this.se_brokermail) reply_mail = this.se_brokermail+",mariana.nagy@xyloimpact.com"

      let hello = this.getTopMsg(this.se_language);
      let message = this.getContentCredit(this.se_language);
      let goodbye = this.getBottomMsg(this.se_language);
      let fromemail = this.getFromEmail(this.se_language);

      // Get signature based on language
      const signature = await this.getSignatureQuote(this.se_language);

      // Pièce jointe : le PDF archivé. Sa présence et ses montants ont déjà été
      // contrôlés par guardBeforeSend ; il ne reste que l'échec de téléchargement,
      // qui est expliqué à l'écran au lieu d'échouer en silence.
      let pdfUrl = this.se_invoice_pdf_url;
      let pdfFilename = this.se_invoice_pdf_filename || `invoice_${this.se_invoice_id}`;
      let pdfBase64 = null;
      try {
        pdfBase64 = await this.fetchInvoicePdfBase64(pdfUrl);
      } catch (error) {
        this.buttonisshow = true;
        this.$vs.loading.close();
        this.reportSendFailure(
          'The invoice PDF could not be downloaded from the server, so the e-mail was not sent. Regenerate the PDF from the invoice screen and try again',
          error
        );
        return;
      }

      var dataz = {
        template_id: "template_cfvx026",
        operation_ids: [this.se_invoice_id], // broker de la facture en Cc (serveur)
        template_params: {
          se_title: title,
          se_hello: hello,
          se_from_email: fromemail,
          se_message: message,
          se_goodbye: goodbye,
          se_reply_mail: reply_mail,
          se_cc: 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com' + (this.se_brokermail ? ',' + this.se_brokermail : ''),
          se_mail: this.datamail,
          se_from_name: this.getName(this.se_language),
          se_signature: signature,
          // SMTP Dynamic Attachment
          attachment_content: pdfUrl || pdfBase64,
          filename: pdfFilename,
          pdf_url: pdfUrl || '',
        },

      };
      axios
        .post("/mail/send", dataz)
        .then((response) => {
          this.insertInDbInvoice();
          this.$vs.notify({
            color: "success",
            title: "Email sent correctly!",
            text:
              "Response from the mail server : " +
              response.statusText +
              "/" +
              response.status,
          });
          this.direct_answer_from_the_server =
            response.statusText + "/" + response.status;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.buttonisshow = true;
          this.reportSendFailure(
            'The mail server refused this e-mail (SMTP). Nothing was delivered to the client',
            error
          );
          this.$vs.loading.close();
        });
    },
    async sendEmailInvoiceAdvance() {
      this.$vs.loading();
      if (!(await this.guardBeforeSend())) {
        this.$vs.loading.close();
        return;
      }
      this.buttonisshow = false;
      let title = this.getTitleAdvance(this.se_language);

      let hello = this.getTopMsg(this.se_language);
      let message = this.getContentAdvance(this.se_language);
      let goodbye = this.getBottomMsg(this.se_language);
      let fromemail = this.getFromEmail(this.se_language);

      let reply_mail = 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com';
      if (this.se_brokermail) reply_mail = this.se_brokermail+",mariana.nagy@xyloimpact.com"

      // Get signature based on language
      const signature = await this.getSignatureQuote(this.se_language);

      // Pièce jointe : le PDF archivé. Sa présence et ses montants ont déjà été
      // contrôlés par guardBeforeSend ; il ne reste que l'échec de téléchargement,
      // qui est expliqué à l'écran au lieu d'échouer en silence.
      let pdfUrl = this.se_invoice_pdf_url;
      let pdfFilename = this.se_invoice_pdf_filename || `invoice_${this.se_invoice_id}`;
      let pdfBase64 = null;
      try {
        pdfBase64 = await this.fetchInvoicePdfBase64(pdfUrl);
      } catch (error) {
        this.buttonisshow = true;
        this.$vs.loading.close();
        this.reportSendFailure(
          'The invoice PDF could not be downloaded from the server, so the e-mail was not sent. Regenerate the PDF from the invoice screen and try again',
          error
        );
        return;
      }

      var dataz = {
        template_id: "template_cfvx026",
        operation_ids: [this.se_invoice_id], // broker de la facture en Cc (serveur)
        template_params: {
          se_title: title,
          se_hello: hello,
          se_from_email: fromemail,
          se_message: message,
          se_goodbye: goodbye,
          se_reply_mail: reply_mail,
          se_cc: 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com' + (this.se_brokermail ? ',' + this.se_brokermail : ''),
          //this.se_user_email
          se_mail: this.datamail,
          se_from_name: this.getName(this.se_language),
          se_signature: signature,
          // SMTP Dynamic Attachment
          attachment_content: pdfUrl || pdfBase64,
          filename: pdfFilename,
          pdf_url: pdfUrl || '',
        },

      };
      axios
        .post("/mail/send", dataz)
        .then((response) => {
          this.insertInDbInvoice();
          this.$vs.notify({
            color: "success",
            title: "Email sent correctly!",
            text:
              "Response from the mail server : " +
              response.statusText +
              "/" +
              response.status,
          });
          this.direct_answer_from_the_server =
            response.statusText + "/" + response.status;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.buttonisshow = true;
          this.reportSendFailure(
            'The mail server refused this e-mail (SMTP). Nothing was delivered to the client',
            error
          );
          this.$vs.loading.close();
        });
    },
    async sendEmailInvoice() {
      this.$vs.loading();
      if (!(await this.guardBeforeSend())) {
        this.$vs.loading.close();
        return;
      }
      this.buttonisshow = false;
      let title = this.getTitleInvoice(this.se_language);

      // Ensure remaining balance preview is up-to-date
      await this.checkRemainingBalanceForPreview();

      let hello = this.getTopMsg(this.se_language);
      let message = this.getContentInvoice(this.se_language, this.previewHasRemainingBalance, this.previewChildQuotationId, this.previewRemainingProducts);
      let goodbye = this.getBottomMsg(this.se_language);
      let fromemail = this.getFromEmail(this.se_language);

      let reply_mail = 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com';
      if (this.se_brokermail) reply_mail = this.se_brokermail+",mariana.nagy@xyloimpact.com"

      // Get signature based on language
      const signature = await this.getSignatureQuote(this.se_language);

      // Pièce jointe : le PDF archivé. Sa présence et ses montants ont déjà été
      // contrôlés par guardBeforeSend ; il ne reste que l'échec de téléchargement,
      // qui est expliqué à l'écran au lieu d'échouer en silence.
      let pdfUrl = this.se_invoice_pdf_url;
      let pdfFilename = this.se_invoice_pdf_filename || `invoice_${this.se_invoice_id}`;
      let pdfBase64 = null;
      try {
        pdfBase64 = await this.fetchInvoicePdfBase64(pdfUrl);
      } catch (error) {
        this.buttonisshow = true;
        this.$vs.loading.close();
        this.reportSendFailure(
          'The invoice PDF could not be downloaded from the server, so the e-mail was not sent. Regenerate the PDF from the invoice screen and try again',
          error
        );
        return;
      }

      var dataz = {
        template_id: "template_cfvx026",
        operation_ids: [this.se_invoice_id], // broker de la facture en Cc (serveur)
        template_params: {
          se_title: title,
          se_hello: hello,
          se_from_email: fromemail,
          se_message: message,
          se_goodbye: goodbye,
          se_reply_mail: reply_mail,
          se_cc: 'sales@acaciabois.com,ferdinand.terlinden@acaciabois.com,mariana.nagy@xyloimpact.com' + (this.se_brokermail ? ',' + this.se_brokermail : ''),
          //this.se_user_email
          se_mail: this.datamail,
          se_from_name: this.getName(this.se_language),
          se_signature: signature,
          // SMTP Dynamic Attachment
          attachment_content: pdfUrl || pdfBase64,
          filename: pdfFilename,
          pdf_url: pdfUrl || '',
        },
      };
      axios
        .post("/mail/send", dataz)
        .then((response) => {
          this.insertInDbInvoice();
          this.$vs.notify({
            color: "success",
            title: "Email sent correctly!",
            text:
              "Response from the mail server : " +
              response.statusText +
              "/" +
              response.status,
          });
          this.direct_answer_from_the_server =
            response.statusText + "/" + response.status;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.buttonisshow = true;
          this.reportSendFailure(
            'The mail server refused this e-mail (SMTP). Nothing was delivered to the client',
            error
          );
          this.$vs.loading.close();
        });
    },
    changethestatus() {
      this.$vs.loading();
      axios
        .post("/paymentreminder/status/transactions/paid", {
          idinvoice: this.invoiceispaid,
          idtransaction: this.idtransaction,
        })
        .then((response) => {
          // L'API dit desormais si un virement a vraiment ete rattache. Sans ce
          // message, une facture passait "payee" pendant que son encaissement
          // restait orphelin dans le rapprochement, sans que personne le sache.
          const warning = response && response.data && response.data.warning
          if (warning) {
            this.$vs.notify({
              color: 'warning',
              title: 'Invoice marked as paid',
              text: warning,
              time: 8000
            })
          }
        })
        .then((response) => {
          this.$store.dispatch(
            "dataListDashboard/fetchTotalValueOfUnpaidInvoice"
          );
          this.$store.dispatch("dataListDashboard/fetchListOfUnpaidInvoice");
          this.$store
            .dispatch("dataListDashboard/fetchSumOfUnpaidInvoiceProvider")
            .then((response) => {
              this.$store
                .dispatch("dataListDashboard/fetchListOfUnpaidInvoiceProvider")
                .then((response) => {
                  this.statuschanged();
                  this.$vs.loading.close();
                });
            });
        })
        .catch(() => { });
    },
    confirmthechangeofthestatus(idinvoice, idtransaction) {
      let phraseVal = "You are about to set the payment status as paid!"
      if (this.popupActiveAccount) {
        this.popupActiveAccount = false;
        this.lastPopup = 1
        phraseVal = `You are about to set the payment status as paid!`
      }
      if (this.popupActiveEur) {
        this.popupActiveEur = false;
        this.lastPopup = 2
        phraseVal = `You are about to hide the transaction!`
      }
      if (this.popupActiveRon) {
        this.popupActiveRon = false;
        this.lastPopup = 3
        phraseVal = `You are about to hide the transaction!`
      }
      this.invoiceispaid = idinvoice;
      this.idtransaction = idtransaction;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Payment status",
        text: phraseVal,
        accept: this.changethestatus,
        acceptText: "Yes!",
      });
    },
    getRmdDetails() { },
    async checkRemainingBalanceForPreview() {
      // Reset preview data
      this.previewHasRemainingBalance = false;
      this.previewChildQuotationId = null;
      this.previewRemainingProducts = [];

      if (!this.se_invoice_id) {
        return Promise.resolve();
      }

      try {
        // Get differences between quotation and invoice
        const differencesResponse = await axios.get(`/operation/getchilddifference/${this.se_invoice_id}`);
        const differences = differencesResponse.data || [];

        // Filter products with non-zero delta_quantity (either missing or added)
        this.previewRemainingProducts = differences.filter(item => parseFloat(item.delta_quantity) != 0);
        this.previewHasRemainingBalance = this.previewRemainingProducts.length > 0;

        if (this.previewHasRemainingBalance) {
          // Find the original quotation
          const invoiceData = await axios.get(`/operation/data/${this.se_invoice_id}`);
          const originalQuotationId = invoiceData.data && invoiceData.data.idquotation_invoice ? invoiceData.data.idquotation_invoice : null;

          if (originalQuotationId) {
            // Find child quotation in quotations list
            const quotationsResponse = await axios.get('/quotation/data');
            const quotations = quotationsResponse.data || [];
            const childQuotation = quotations.find(q => q.idparent === originalQuotationId);

            if (childQuotation && childQuotation.id) {
              this.previewChildQuotationId = childQuotation.id;
            }

            // Enrich remaining products with translated descriptions
            try {
              const quotationData = await axios.get(`/operation/data/${originalQuotationId}`)
              const quotationProducts = (quotationData.data && quotationData.data.products) || []
              const invoiceProducts = (invoiceData.data && invoiceData.data.products) || []
              const sourceProducts = [...invoiceProducts, ...quotationProducts]
              let translationIndex = null

              // Prefer quotation PDF product list (missing items come from quotation)
              try {
                const languageId =
                  this.se_language_id ||
                  (quotationData.data && quotationData.data.people && quotationData.data.people[0] &&
                    quotationData.data.people[0].language && quotationData.data.people[0].language.id) ||
                  (invoiceData.data && invoiceData.data.people && invoiceData.data.people[0] &&
                    invoiceData.data.people[0].language && invoiceData.data.people[0].language.id) ||
                  await this.resolveLanguageId(this.se_language)

                if (languageId) {
                  this.se_language_id = languageId
                  const englishLanguageId = await this.resolveLanguageId('en')
                  const translatedPromise = axios.get(`/getproductlistpdf/${originalQuotationId}/${languageId}`)
                  const englishPromise = englishLanguageId && englishLanguageId !== languageId
                    ? axios.get(`/getproductlistpdf/${originalQuotationId}/${englishLanguageId}`)
                    : Promise.resolve({ data: [] })
                  const [translatedResponse, englishResponse] = await Promise.all([translatedPromise, englishPromise])
                  const translatedProducts = translatedResponse.data || []
                  const englishProducts = englishResponse.data || []
                  translationIndex = this.buildProductTranslationIndex(translatedProducts, englishProducts)
                }
              } catch (pdfError) {
                console.error('Preview - PDF product list not available (broker):', pdfError)
              }
              this.previewRemainingProducts = this.previewRemainingProducts.map(item => ({
                ...item,
                devis_description_translated_client:
                  this.getTranslatedDescriptionFromIndex(item, translationIndex) ||
                  item.devis_description_translated_client ||
                  this.getTranslatedProductNameForDifference(item, sourceProducts, this.se_language)
              }))
            } catch (translationError) {
              console.error('Preview - Translation enrichment failed (broker):', translationError)
            }
          }
        }
      } catch (error) {
        console.error('Error checking for remaining balance in preview (broker):', error);
      }

      return Promise.resolve();
    },
    async fillInTheForm(data, whichone) {
      // Nouveau document : diagnostic remis à zéro, sinon le message d'erreur
      // de la facture précédente resterait affiché.
      this.sendIssues = { blockers: [], warnings: [] };
      this.sendFailure = null;
      this.se_broker = data.broker,
      this.se_brokermail = data.emailbroker,
      this.se_idmajoration = null
      this.se_facture_no = data.invoice_no;
      this.se_montant = Math.abs(data.prix).toFixed(2).toLocaleString();
      this.se_idmajoration = data.idinvoicemajoration
      this.se_invoice_id = data.id;
      this.se_user_name = data.client;
      this.se_user_email = data.email;
      this.se_date = data.deadline;
      this.se_user_id = data.clientid;
      this.se_language = data.langue;
      this.se_language_id = data.idlangue;
      this.se_whichone = whichone;

      // Extract PDF URL and filename from data.name
      if (data.name) {
        this.se_invoice_pdf_url = data.name;

        // Split by '/' and get the last element (filename)
        const urlParts = data.name.split('/');
        const maxIndex = urlParts.length - 1;
        this.se_invoice_pdf_filename = urlParts[maxIndex] || `invoice_${this.se_invoice_id}.pdf`;
      } else {
        this.se_invoice_pdf_url = null;
        this.se_invoice_pdf_filename = null;
      }

      // Adresse de livraison : d'abord ce que la ligne du tableau porte deja
      // (jointure sur operations.idaddressdelivery dans /paymentreminder/data),
      // sinon on demande a l'API de remonter la cascade.
      const hasDetailRow = data.detail && Array.isArray(data.detail) && data.detail.length > 0 && data.detail[0];
      const rowAddress = hasDetailRow ? data.detail[0] : data;

      if (this.isUsableAddress(rowAddress)) {
        this.se_delivery_address = {
          street: rowAddress.street || '',
          number: rowAddress.number || '',
          postal_code: rowAddress.postal_code || '',
          place_name: rowAddress.place_name || '',
          region: rowAddress.region || '',
          name_en: rowAddress.name_en || ''
        };
        this.se_delivery_address_source = 'operation_delivery';
      } else {
        this.se_delivery_address = null;
        this.se_delivery_address_source = null;
        await this.resolveDeliveryAddressForInvoice(this.se_invoice_id);
      }

      if (this.se_whichone === 'Send invoice to client') {
        let title = null
        // Load remaining balance preview for invoice differences
        await this.checkRemainingBalanceForPreview();
        this.se_content = "<br/><br/>" + this.getTopMsg(this.se_language);
        this.se_content = this.se_content + " " + this.getContentInvoice(this.se_language, this.previewHasRemainingBalance, this.previewChildQuotationId, this.previewRemainingProducts);
        this.se_content = this.se_content + " " + this.getBottomMsg(this.se_language);
        this.se_title = title
      }
      else if (this.se_whichone === 'Send advance to client') {
        let title = null
        this.se_content = "<br/><br/>" + this.getTopMsg(this.se_language);
        this.se_content = this.se_content + " " + this.getContentAdvance(this.se_language);
        this.se_content = this.se_content + " " + this.getBottomMsg(this.se_language);
        this.se_title = title
      }
      else if (this.se_whichone === 'Send credit note to client') {
        let title = null
        this.se_content = "<br/><br/>" + this.getTopMsg(this.se_language);
        this.se_content = this.se_content + " " + this.getContentCredit(this.se_language);
        this.se_content = this.se_content + " " + this.getBottomMsg(this.se_language);
        this.se_title = title
      }
      else {
        try {
          let title = null
          this.se_title = null
          this.se_content = null
          if (this.extractNumber(this.se_whichone) == 1) title = this.getTitleFirstReminder(this.se_language);
          else if (this.extractNumber(this.se_whichone) == 2) title = this.getTitleSecondReminder(this.se_language);
          else if (this.extractNumber(this.se_whichone) == 3) title = this.getTitleThirdReminder(this.se_language);
          else if (this.extractNumber(this.se_whichone) == 4) title = this.getTitleMajorationReminder(this.se_language);
          this.se_title = title
          this.se_content = "<br/><br/>" + this.getTopMsg(this.se_language);
          if (this.extractNumber(this.se_whichone) == 3) this.se_content = this.se_content + "<br/><br/>" + this.getThirdContent(this.se_language);
          else if (this.extractNumber(this.se_whichone) == 4) this.se_content = this.se_content + "<br/><br/>" + this.getMajorationContent(this.se_language);
          else this.se_content = this.se_content + " " + this.getContent(this.se_language);
          this.se_content = this.se_content + " " + this.getBottomMsg(this.se_language);

        } catch (error) {
          alert(error)
        }
      }

      // Generate signature for preview (except for majoration)
      if (this.se_whichone && !this.se_whichone.toString().toLowerCase().includes('reminder 4') && !this.se_whichone.toString().toLowerCase().includes('majoration')) {
        this.se_signature = await this.getSignatureQuote(this.se_language);
      } else {
        this.se_signature = null;
      }
    },
    async openThePopupSendMailMajoration(issent, data) {
      // Reset and populate current client's emails to avoid stale selection
      this.data_options_mail = []
      this.datamail = []
      this.se_user_email = ''
      if (issent) {
        this.popupActive = true;
        this.direct_answer_from_the_server = "OK/200";
        await this.fillInTheForm(data, "Reminder 4");
        this.buttonisshow = false;
        this.populateEmailOptions(data);
      } else {
        if (!data.idinvoicemajoration) {
          await this.getNewInvoiceNr(data)
          this.se_tva = Math.round((this.getVat(data.subject_vat, data.country_code) % 1) * 100);
          this.popupActiveCreateMajorationInvoice = true;
          await this.fillInTheForm(data, "Reminder 4");
          this.populateEmailOptions(data);
        }
        else {
          this.popupActive = true;
          this.direct_answer_from_the_server = null;
          this.buttonisshow = true;
          await this.fillInTheForm(data, "Reminder 4");
          this.populateEmailOptions(data);
        }
      }
    },
    async getNewInvoiceNr(data) {
      axios
        .get(
          "/sale/getnextinvoicenr/" +
          moment().add(12, "hours").format("YYYY") +
          ""
        )
        .then((response) => {
          try {
            if (data.country_code.includes("RO")) {
              this.dataNextInvoiceNr = response.data.next_invoice_no.ro;
            } else {
              this.dataNextInvoiceNr = response.data.next_invoice_no.eu;
            }
          } catch (error) {
            alert(error)
          }
        })
        .catch((error) => { });
    },
    async openThePopupSendMail(issent, data) {
      this.data_options_mail = []
      this.datamail = []
      this.se_user_email = ''
      if (data.iscreditnote) {
        if (issent) {
          this.popupActive = true;
          this.direct_answer_from_the_server = "OK/200";
          await this.fillInTheForm(data, "Send credit note to client");
          this.buttonisshow = false;
          this.populateEmailOptions(data);
        }
        else {
          this.popupActive = true;
          this.direct_answer_from_the_server = null;
          this.buttonisshow = true;
          await this.fillInTheForm(data, "Send credit note to client");
          this.populateEmailOptions(data);
        }

      }
      if (data.isadvanceinvoice) {
        if (issent) {
          this.popupActive = true;
          this.direct_answer_from_the_server = "OK/200";
          await this.fillInTheForm(data, "Send advance to client");
          this.buttonisshow = false;
          this.populateEmailOptions(data);
        }
        else {
          this.popupActive = true;
          this.direct_answer_from_the_server = null;
          this.buttonisshow = true;
          await this.fillInTheForm(data, "Send advance to client");
          this.populateEmailOptions(data);
        }
      }
      else if (!data.iscreditnote && !data.isadvanceinvoice){
        if (issent) {
          this.popupActive = true;
          this.direct_answer_from_the_server = "OK/200";
          await this.fillInTheForm(data, "Send invoice to client");
          this.buttonisshow = false;
          this.populateEmailOptions(data);
        } else {
          this.popupActive = true;
          this.direct_answer_from_the_server = null;
          this.buttonisshow = true;
          await this.fillInTheForm(data, "Send invoice to client");
          this.populateEmailOptions(data);
        }
      }
    },
    async openThePopup(rmdstring, whichone, data) {
      if (this.getReminderStatusColor(rmdstring, whichone) === "success") {
        this.popupActive = true;
        this.direct_answer_from_the_server = "OK/200";
        await this.fillInTheForm(data, "Reminder " + whichone);
        this.buttonisshow = false;
        this.populateEmailOptions(data);
      } else {
        this.se_user_email = ''
        this.popupActive = true;
        this.direct_answer_from_the_server = null;
        this.buttonisshow = true;
        await this.fillInTheForm(data, "Reminder " + whichone);
        this.populateEmailOptions(data);
      }
    },
    getSendMailColor(issent) {
      //1,First rappel → 2019-01-01;3,Second rappel → 2019-01-04
      try {
        if (issent) {
          return "success";
        } else return "warning";
      } catch (error) {
        return "warning";
      }
    },
    getReminderStatusColor(rmdstring, whichone) {
      //1,First rappel → 2019-01-01;3,Second rappel → 2019-01-04
      try {
        if (rmdstring.includes(",")) {
          let theSplitted = this.splitedListPointVirgule(rmdstring);
          if (theSplitted.length == 1 && whichone == 1) {
            return "success";
          } else if (theSplitted.length == 1 && whichone == 2) {
            return "warning";
          } else if (theSplitted.length == 2 && whichone == 1) {
            return "success";
          } else if (theSplitted.length == 2 && whichone == 2) {
            return "success";
          } else if (theSplitted.length == 3 && whichone == 1) {
            return "success";
          } else if (theSplitted.length == 3 && whichone == 2) {
            return "success";
          } else if (theSplitted.length == 3 && whichone == 3) {
            return "success";
          } else {
            return "warning";
          }
        } else {
          return "warning";
        }
      } catch (error) {
        return "warning";
      }
    },
    getReminderStatus(rmdstring, whichone) {
      //1,First rappel → 2019-01-01;2,Second rappel → 2019-01-04
      try {
        if (rmdstring.includes(",")) {
          // Gestion avec 1 rappel
          let theSplitted = this.splitedListPointVirgule(rmdstring);
          //console.log(rmdstring + " " + whichone + " length => " + theSplitted.length)
          if (theSplitted.length == 1 && whichone == 1) {
            let thedate = this.splitedListVirgule(theSplitted[0]);
            if (parseInt(thedate[2]) == 1) return "Sent yesterday" + " (" + thedate[3] + ")";
            else if (parseInt(thedate[2]) == 0) return "Sent today" + " (" + thedate[3] + ")";
            else return ("Sent " + thedate[2] + " days ago" + " (" + thedate[3] + ")");
          }
          // Gestion avec 2 rappels
          else if (theSplitted.length == 1 && whichone == 2) return "Not sent!";
          else if (theSplitted.length == 2 && whichone == 1) {
            let thedate = this.splitedListVirgule(theSplitted[0]);
            if (parseInt(thedate[2]) == 1) return "Sent yesterday" + " (" + thedate[3] + ")";
            else if (parseInt(thedate[2]) == 0) return "Sent today" + " (" + thedate[3] + ")";
            else return ("Sent " + thedate[2] + " days ago" + " (" + thedate[3] + ")");
          }
          else if (theSplitted.length == 2 && whichone == 2) {
            let thedate = this.splitedListVirgule(theSplitted[1]);
            if (parseInt(thedate[2]) == 1) return "Sent yesterday" + " (" + thedate[3] + ")";
            else if (parseInt(thedate[2]) == 0) return "Sent today" + " (" + thedate[3] + ")";
            else return ("Sent " + thedate[2] + " days ago" + " (" + thedate[3] + ")");
          }
          // Gestion avec 3 rappels
          else if (theSplitted.length == 1 && whichone == 3) return "Not sent!"; //"1/3";
          else if (theSplitted.length == 1 && whichone == 2) return "Not sent!";//"1/2";
          else if (theSplitted.length == 1 && whichone == 1) return "Not sent!";//"1/1";
          else if (theSplitted.length == 2 && whichone == 3) return "Not sent!";// "2/2";
          else if (theSplitted.length == 2 && whichone == 2) return "Not sent!";//"2/2";
          else if (theSplitted.length == 2 && whichone == 1) return "Not sent!";//"2/1";
          else if (theSplitted.length == 3 && whichone == 3) {
            let thedate = this.splitedListVirgule(theSplitted[2]);
            if (parseInt(thedate[2]) == 1) return "Sent yesterday" + " (" + thedate[3] + ")";
            else if (parseInt(thedate[2]) == 0) return "Sent today" + " (" + thedate[3] + ")";
            else return ("Sent " + thedate[2] + " days ago" + " (" + thedate[3] + ")");
          }
          else if (theSplitted.length == 3 && whichone == 2) {
            let thedate = this.splitedListVirgule(theSplitted[1]);
            if (parseInt(thedate[2]) == 0) return "Sent today" + " (" + thedate[3] + ")";
            else return ("Sent " + thedate[2] + " days ago" + " (" + thedate[3] + ")");
          }
          else if (theSplitted.length == 3 && whichone == 1) {
            let thedate = this.splitedListVirgule(theSplitted[0]);
            if (parseInt(thedate[2]) == 1) return "Sent yesterday" + " (" + thedate[3] + ")";
            else if (parseInt(thedate[2]) == 0) return "Sent today" + " (" + thedate[3] + ")";
            else return ("Sent " + thedate[2] + " days ago" + " (" + thedate[3] + ")");
          }
          else return "Not sent!";
        } else return "Not sent!";
      } catch (error) {
        return "Not sent!";
      }
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    gotoclient(id) {
      return { path: "/person-edit/" + id };
    },
    splitedListPointVirgule(row) {
      return row !== null ? row.split(";") : "";
    },
    splitedListVirgule(row) {
      return row !== null ? row.split(",") : "";
    },
    async initGraphiqueCumulated() {
    },
  },
  created() {
    this.$vs.loading();
      this.displayExport = true;
      if (!moduleDataListDashboard.isRegistered) {
        this.$store.registerModule(
          "dataListDashboard",
          moduleDataListDashboard
        );
        moduleDataListDashboard.isRegistered = true;
      }
      this.$store
        .dispatch("dataListDashboard/fetchTotalValueOfUnpaidInvoice")
        .then((response) => {
          this.$store
            .dispatch("dataListDashboard/fetchListOfUnpaidInvoiceBroker")
            .then((response) => {
              this.$vs.loading.close();
            });
        });

  },
};
</script>
<style lang="scss">
.legend {
  display: flex;
  float: right;
  flex-wrap: wrap;
  /* Permet le retour à la ligne si nécessaire */
  gap: 1rem;
  /* Espacement entre les éléments */
}

.legend-item {
  display: flex;
  align-items: center;
  /* Aligne le texte avec la pastille */
  gap: 0.5rem;
  /* Espacement entre la pastille et le texte */
}


.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Espacer le titre et l'image */
}

.header h4 {
  margin: 0;
  /* Enlever la marge par défaut du titre pour un alignement correct */
}

.header img {
  height: 64px;
  /* Ajuster la taille de l'image selon le besoin */
}


#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

.institution {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.institution:hover {
  background-color: #e6f7ff;
}

.institution img {
  margin-right: 15px;
  border-radius: 5px;
}

.institution-info {
  flex-grow: 1;
}

.dispute-badge {
  display: inline-block;
  background-color: #DC2626;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 6px;
  vertical-align: middle;
  animation: dispute-pulse 1.5s ease-in-out infinite;
}

@keyframes dispute-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.dispute-comment {
  color: #DC2626;
  font-style: italic;
}

/*! rtl:end:ignore */
</style>
